/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var React = __webpack_require__(1);
	var react_dom_1 = __webpack_require__(3);
	var react_router_1 = __webpack_require__(4);
	var helpers_1 = __webpack_require__(5);
	// Components
	var Layout_1 = __webpack_require__(6);
	var Main_1 = __webpack_require__(8);
	var Sony_1 = __webpack_require__(37);
	var Members_1 = __webpack_require__(40);
	var Visitors_1 = __webpack_require__(41);
	var NewsRead_1 = __webpack_require__(43);
	var Paid_1 = __webpack_require__(44);
	var Accounting_1 = __webpack_require__(45);
	var Dashboard_1 = __webpack_require__(46);
	var Restricted_1 = __webpack_require__(47);
	var Table_1 = __webpack_require__(48);
	react_router_1.browserHistory.listen(function (_a) {
	    var action = _a.action, pathname = _a.pathname;
	    if (action === 'PUSH') {
	        helpers_1.historyState.pushes++;
	    }
	    else if (action === 'POP') {
	        helpers_1.historyState.pops++;
	    }
	});
	exports.result = react_dom_1.render(React.createElement(react_router_1.Router, {history: react_router_1.browserHistory, onUpdate: helpers_1.scrollOnUpdate}, 
	    React.createElement(react_router_1.Route, {component: Layout_1.Layout}, 
	        React.createElement(react_router_1.Route, {path: "/", component: Main_1.Main}), 
	        React.createElement(react_router_1.Route, {path: "/members", component: Members_1.Members}), 
	        React.createElement(react_router_1.Route, {path: "/sony", component: Sony_1.Sony}), 
	        React.createElement(react_router_1.Route, {path: "/visitors", component: Visitors_1.Visitors}), 
	        React.createElement(react_router_1.Route, {path: "/news/:id", component: NewsRead_1.NewsRead}), 
	        React.createElement(react_router_1.Route, {path: "/paid/:id", component: Paid_1.Paid})), 
	    React.createElement(react_router_1.Route, {component: Restricted_1.Restricted}, 
	        React.createElement(react_router_1.Route, {path: "/dashboard", component: Dashboard_1.Dashboard}), 
	        React.createElement(react_router_1.Route, {path: "/dashboard/accounting", component: Accounting_1.Accounting})), 
	    React.createElement(react_router_1.Route, {path: "/table/:table", component: Table_1.Table})), document.getElementById("container"));


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(6);

/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = vendor;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(79);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(152);

/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	function assets(res) {
	    return '/assets/' + res;
	}
	exports.assets = assets;
	function scrollOnUpdate() {
	    var action = this.state.location.action;
	    if (action === 'PUSH') {
	        window.scrollTo(0, 0);
	    }
	}
	exports.scrollOnUpdate = scrollOnUpdate;
	exports.historyState = {
	    pushes: 0,
	    pops: 0
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var react_router_1 = __webpack_require__(4);
	var helpers_1 = __webpack_require__(5);
	var $ = __webpack_require__(7);
	window['$'] = $;
	window['jQuery'] = $;
	var Layout = (function (_super) {
	    __extends(Layout, _super);
	    function Layout() {
	        _super.apply(this, arguments);
	    }
	    Layout.prototype.componentWillUnmount = function () {
	        var $nav = $('nav');
	        $nav.find('a').off('click');
	    };
	    Layout.prototype.componentDidMount = function () {
	        $('.icons').find('A').on('click', function (e) {
	            e.preventDefault();
	            var $rel = $(this), shareUrl = $rel.attr('href');
	            shareUrl = shareUrl.replace('{title}', $('head meta[property="og:title"]'));
	            shareUrl = shareUrl.replace('{text}', $('head meta[property="og:description"]'));
	            if ($rel.data('tab')) {
	                window.open(shareUrl);
	            }
	            else {
	                window.open(shareUrl, $rel.attr('class').split(' ')[1], 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
	            }
	        });
	    };
	    Layout.prototype.render = function () {
	        return (React.createElement("div", null, 
	            React.createElement("header", null, 
	                React.createElement(react_router_1.Link, {to: "/"}, 
	                    React.createElement("img", {src: helpers_1.assets('logo-loudhead.png')})
	                ), 
	                React.createElement("nav", null, 
	                    React.createElement(react_router_1.Link, {to: "/visitors"}, "Посетителям"), 
	                    React.createElement(react_router_1.Link, {to: "/members"}, "Участникам"), 
	                    React.createElement("a", {href: "/#about"}, "О выставке"), 
	                    React.createElement("a", {href: "/#contacts"}, "Контакты"))), 
	            this.props.children, 
	            React.createElement("footer", null, 
	                React.createElement("a", {name: "contacts"}), 
	                React.createElement("div", {className: "info"}, 
	                    React.createElement("aside", {className: "contacts"}, 
	                        React.createElement("h4", null, "Оргкомитет"), 
	                        React.createElement("address", null, 
	                            React.createElement("strong", null, "Литвиненко Надежда Михайловна"), 
	                            React.createElement("br", null), 
	                            "Тел.: +7 (495) 212-10-51 ", 
	                            React.createElement("br", null), 
	                            "Тел.: 8 (916) 465-80-17 ", 
	                            React.createElement("br", null), 
	                            "E-mail:  ", 
	                            atob('b3JnQGxvdWRoZWFkLnJ1'))), 
	                    React.createElement("aside", {className: "partners"}, 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "col-md-6"}, 
	                                React.createElement("a", {href: "https://doctorhead.ru/", target: "_blank"}, 
	                                    React.createElement("img", {src: helpers_1.assets("drhead-logo.png")})
	                                )
	                            ), 
	                            React.createElement("div", {className: "col-md-6"}, 
	                                React.createElement("a", {href: "http://stereo.ru/", target: "_blank"}, 
	                                    React.createElement("img", {src: helpers_1.assets("stereoru-logo.png")})
	                                )
	                            ), 
	                            React.createElement("div", {className: "col-md-6"}, 
	                                React.createElement("a", {href: "http://personalaudio.ru/", target: "_blank"}, 
	                                    React.createElement("img", {src: helpers_1.assets("pa-logo.png")})
	                                )
	                            ))
	                    )), 
	                React.createElement("div", {className: "bottom"}, 
	                    React.createElement("b", null, 
	                        "LOUDHEAD 2014-", 
	                        new Date().getFullYear()), 
	                    React.createElement("div", {className: "icons"}, 
	                        React.createElement("a", {href: "http://twitter.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Ftw", target: "_blank", className: "icon icon-tw"}), 
	                        React.createElement("a", {href: "http://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Floudhead.ru%2F%3Ffb", target: "_blank", className: "icon icon-fb"}), 
	                        React.createElement("a", {href: "https://plus.google.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Fgp", target: "_blank", className: "icon icon-gp"}))))));
	    };
	    return Layout;
	}(React.Component));
	exports.Layout = Layout;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(134);

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var MainBanner_1 = __webpack_require__(9);
	var AboutConference_1 = __webpack_require__(25);
	var GalleryConference_1 = __webpack_require__(27);
	var PressConference_1 = __webpack_require__(29);
	var PressConference2016_1 = __webpack_require__(30);
	var Brands_1 = __webpack_require__(31);
	var News_1 = __webpack_require__(32);
	var Main = (function (_super) {
	    __extends(Main, _super);
	    function Main() {
	        _super.apply(this, arguments);
	    }
	    Main.prototype.render = function () {
	        return (React.createElement("div", null, 
	            React.createElement(MainBanner_1.MainBanner, null), 
	            React.createElement(PressConference2016_1.PressConference2016, null), 
	            React.createElement(News_1.News, null), 
	            React.createElement(AboutConference_1.AboutConference, null), 
	            React.createElement(GalleryConference_1.GalleryConference, null), 
	            React.createElement(PressConference_1.PressConference, null), 
	            React.createElement(Brands_1.Brands, null)));
	    };
	    return Main;
	}(React.Component));
	exports.Main = Main;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var ReactPlayer = __webpack_require__(10);
	var MainBanner = (function (_super) {
	    __extends(MainBanner, _super);
	    function MainBanner(props) {
	        var _this = this;
	        _super.call(this, props);
	        /*private open(e) {
	            e.preventDefault();
	            this.setState({open: true});
	            window.scrollTo(0, 0);
	        }*/
	        this.playPause = function (e) {
	            _this.setState({ playing: !_this.state.playing });
	        };
	        this.state = {
	            playing: false
	        };
	    }
	    MainBanner.prototype.render = function () {
	        var banner = this.props.compact ? helpers_1.assets("bn-2016-min.png") : helpers_1.assets("bn-2016.png");
	        return (React.createElement("div", null, 
	            React.createElement("section", {id: "bn-2016", className: "heading"}, 
	                React.createElement("a", {href: "https://doctorhead.ru/promo/loudhead-competition/", target: "_blank"}, 
	                    React.createElement("img", {src: helpers_1.assets("competition-1.png"), width: "100%"})
	                )
	            ), 
	            React.createElement("div", {id: "player", onClick: this.playPause}, 
	                React.createElement("h1", null, "Видео с выставки LOUDHEAD 2016"), 
	                this.state.playing === false && React.createElement("div", {className: "play"}, " "), 
	                React.createElement(ReactPlayer, {fileConfig: { controls: true }, className: "player", url: "/video/2016.mp4", playing: this.state.playing, width: "100%", height: "auto"}))));
	    };
	    return MainBanner;
	}(React.Component));
	exports.MainBanner = MainBanner;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _props3 = __webpack_require__(11);
	
	var _YouTube = __webpack_require__(12);
	
	var _YouTube2 = _interopRequireDefault(_YouTube);
	
	var _SoundCloud = __webpack_require__(16);
	
	var _SoundCloud2 = _interopRequireDefault(_SoundCloud);
	
	var _Vimeo = __webpack_require__(19);
	
	var _Vimeo2 = _interopRequireDefault(_Vimeo);
	
	var _FilePlayer = __webpack_require__(18);
	
	var _FilePlayer2 = _interopRequireDefault(_FilePlayer);
	
	var _Streamable = __webpack_require__(23);
	
	var _Streamable2 = _interopRequireDefault(_Streamable);
	
	var _Vidme = __webpack_require__(24);
	
	var _Vidme2 = _interopRequireDefault(_Vidme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlayer = function (_Component) {
	  _inherits(ReactPlayer, _Component);
	
	  function ReactPlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayer.__proto__ || Object.getPrototypeOf(ReactPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.seekTo = function (fraction) {
	      if (_this.player) {
	        _this.player.seekTo(fraction);
	      }
	    }, _this.progress = function () {
	      if (_this.props.url && _this.player) {
	        var loaded = _this.player.getFractionLoaded() || 0;
	        var played = _this.player.getFractionPlayed() || 0;
	        var progress = {};
	        if (loaded !== _this.prevLoaded) {
	          progress.loaded = loaded;
	        }
	        if (played !== _this.prevPlayed && _this.props.playing) {
	          progress.played = played;
	        }
	        if (progress.loaded || progress.played) {
	          _this.props.onProgress(progress);
	        }
	        _this.prevLoaded = loaded;
	        _this.prevPlayed = played;
	      }
	      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
	    }, _this.ref = function (player) {
	      _this.player = player;
	    }, _this.renderPlayer = function (Player) {
	      var active = Player.canPlay(_this.props.url);
	      var _this$props = _this.props;
	      var youtubeConfig = _this$props.youtubeConfig;
	      var soundcloudConfig = _this$props.soundcloudConfig;
	      var vimeoConfig = _this$props.vimeoConfig;
	      var fileConfig = _this$props.fileConfig;
	
	      var activeProps = _objectWithoutProperties(_this$props, ['youtubeConfig', 'soundcloudConfig', 'vimeoConfig', 'fileConfig']);
	
	      var props = active ? _extends({}, activeProps, { ref: _this.ref }) : {};
	      return _react2['default'].createElement(Player, _extends({
	        key: Player.displayName,
	        youtubeConfig: youtubeConfig,
	        soundcloudConfig: soundcloudConfig,
	        vimeoConfig: vimeoConfig,
	        fileConfig: fileConfig
	      }, props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.progress();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.progressTimeout);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.volume !== nextProps.volume || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
	    }
	  }, {
	    key: 'renderPlayers',
	    value: function renderPlayers() {
	      // Build array of players to render based on URL and preload config
	      var _props = this.props;
	      var url = _props.url;
	      var youtubeConfig = _props.youtubeConfig;
	      var vimeoConfig = _props.vimeoConfig;
	
	      var players = [];
	      if (_YouTube2['default'].canPlay(url)) {
	        players.push(_YouTube2['default']);
	      } else if (_SoundCloud2['default'].canPlay(url)) {
	        players.push(_SoundCloud2['default']);
	      } else if (_Vimeo2['default'].canPlay(url)) {
	        players.push(_Vimeo2['default']);
	      } else if (_Streamable2['default'].canPlay(url)) {
	        players.push(_Streamable2['default']);
	      } else if (_Vidme2['default'].canPlay(url)) {
	        players.push(_Vidme2['default']);
	      } else if (url) {
	        // Fall back to FilePlayer if nothing else can play the URL
	        players.push(_FilePlayer2['default']);
	      }
	      // Render additional players if preload config is set
	      if (!_YouTube2['default'].canPlay(url) && youtubeConfig.preload) {
	        players.push(_YouTube2['default']);
	      }
	      if (!_Vimeo2['default'].canPlay(url) && vimeoConfig.preload) {
	        players.push(_Vimeo2['default']);
	      }
	      return players.map(this.renderPlayer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var style = _props2.style;
	      var width = _props2.width;
	      var height = _props2.height;
	      var className = _props2.className;
	      var hidden = _props2.hidden;
	
	      var players = this.renderPlayers();
	      return _react2['default'].createElement(
	        'div',
	        { style: _extends({}, style, { width: width, height: height }), className: className, hidden: hidden },
	        players
	      );
	    }
	  }]);
	
	  return ReactPlayer;
	}(_react.Component);
	
	ReactPlayer.displayName = 'ReactPlayer';
	ReactPlayer.propTypes = _props3.propTypes;
	ReactPlayer.defaultProps = _props3.defaultProps;
	exports['default'] = ReactPlayer;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var string = _react.PropTypes.string;
	var bool = _react.PropTypes.bool;
	var number = _react.PropTypes.number;
	var oneOfType = _react.PropTypes.oneOfType;
	var shape = _react.PropTypes.shape;
	var object = _react.PropTypes.object;
	var func = _react.PropTypes.func;
	var propTypes = exports.propTypes = {
	  url: string,
	  playing: bool,
	  loop: bool,
	  controls: bool,
	  volume: number,
	  width: oneOfType([string, number]),
	  height: oneOfType([string, number]),
	  hidden: bool,
	  className: string,
	  style: object,
	  progressFrequency: number,
	  soundcloudConfig: shape({
	    clientId: string,
	    showArtwork: bool
	  }),
	  youtubeConfig: shape({
	    playerVars: object,
	    preload: bool
	  }),
	  vimeoConfig: shape({
	    iframeParams: object,
	    preload: bool
	  }),
	  fileConfig: shape({
	    attributes: object
	  }),
	  onReady: func,
	  onStart: func,
	  onPlay: func,
	  onPause: func,
	  onBuffer: func,
	  onEnded: func,
	  onError: func,
	  onDuration: func,
	  onProgress: func
	};
	
	var defaultProps = exports.defaultProps = {
	  playing: false,
	  loop: false,
	  controls: false,
	  volume: 0.8,
	  width: 640,
	  height: 360,
	  hidden: false,
	  progressFrequency: 1000,
	  soundcloudConfig: {
	    clientId: 'e8b6f84fbcad14c301ca1355cae1dea2',
	    showArtwork: true
	  },
	  youtubeConfig: {
	    playerVars: {},
	    preload: false
	  },
	  vimeoConfig: {
	    iframeParams: {},
	    preload: false
	  },
	  fileConfig: {
	    attributes: {}
	  },
	  onReady: function onReady() {},
	  onStart: function onStart() {},
	  onPlay: function onPlay() {},
	  onPause: function onPause() {},
	  onBuffer: function onBuffer() {},
	  onEnded: function onEnded() {},
	  onError: function onError() {},
	  onDuration: function onDuration() {},
	  onProgress: function onProgress() {}
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loadScript = __webpack_require__(13);
	
	var _loadScript2 = _interopRequireDefault(_loadScript);
	
	var _Base2 = __webpack_require__(14);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _utils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SDK_URL = 'https://www.youtube.com/iframe_api';
	var SDK_GLOBAL = 'YT';
	var SDK_GLOBAL_READY = 'onYouTubeIframeAPIReady';
	var MATCH_URL = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
	var BLANK_VIDEO_URL = 'https://www.youtube.com/watch?v=GlCmAC4MHek';
	var DEFAULT_PLAYER_VARS = {
	  autoplay: 0,
	  playsinline: 1,
	  showinfo: 0,
	  rel: 0,
	  iv_load_policy: 3
	};
	
	var YouTube = function (_Base) {
	  _inherits(YouTube, _Base);
	
	  function YouTube() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YouTube);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call.apply(_ref, [this].concat(args))), _this), _this.onStateChange = function (_ref2) {
	      var data = _ref2.data;
	      var _this$props = _this.props;
	      var onPause = _this$props.onPause;
	      var onBuffer = _this$props.onBuffer;
	      var _window$SDK_GLOBAL$Pl = window[SDK_GLOBAL].PlayerState;
	      var PLAYING = _window$SDK_GLOBAL$Pl.PLAYING;
	      var PAUSED = _window$SDK_GLOBAL$Pl.PAUSED;
	      var BUFFERING = _window$SDK_GLOBAL$Pl.BUFFERING;
	      var ENDED = _window$SDK_GLOBAL$Pl.ENDED;
	      var CUED = _window$SDK_GLOBAL$Pl.CUED;
	
	      if (data === PLAYING) _this.onPlay();
	      if (data === PAUSED) onPause();
	      if (data === BUFFERING) onBuffer();
	      if (data === ENDED) _this.onEnded();
	      if (data === CUED) _this.onReady();
	    }, _this.onEnded = function () {
	      var _this$props2 = _this.props;
	      var loop = _this$props2.loop;
	      var onEnded = _this$props2.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.ref = function (container) {
	      _this.container = container;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YouTube, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var url = _props.url;
	      var youtubeConfig = _props.youtubeConfig;
	
	      if (!url && youtubeConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'getSDK',
	    value: function getSDK() {
	      if (window[SDK_GLOBAL] && window[SDK_GLOBAL].loaded) {
	        return Promise.resolve(window[SDK_GLOBAL]);
	      }
	      return new Promise(function (resolve, reject) {
	        var previousOnReady = window[SDK_GLOBAL_READY];
	        window[SDK_GLOBAL_READY] = function () {
	          if (previousOnReady) previousOnReady();
	          resolve(window[SDK_GLOBAL]);
	        };
	        (0, _loadScript2['default'])(SDK_URL, function (err) {
	          if (err) reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var controls = _props2.controls;
	      var youtubeConfig = _props2.youtubeConfig;
	      var _onError = _props2.onError;
	
	      var id = url && url.match(MATCH_URL)[1];
	      if (this.isReady) {
	        this.player.cueVideoById({
	          videoId: id,
	          startSeconds: (0, _utils.parseStartTime)(url)
	        });
	        return;
	      }
	      if (this.loadingSDK) {
	        this.loadOnReady = url;
	        return;
	      }
	      this.loadingSDK = true;
	      this.getSDK().then(function (YT) {
	        _this2.player = new YT.Player(_this2.container, {
	          width: '100%',
	          height: '100%',
	          videoId: id,
	          playerVars: _extends({}, DEFAULT_PLAYER_VARS, {
	            controls: controls ? 1 : 0
	          }, youtubeConfig.playerVars, {
	            start: (0, _utils.parseStartTime)(url),
	            origin: window.location.origin
	          }),
	          events: {
	            onReady: function onReady() {
	              _this2.loadingSDK = false;
	              _this2.onReady();
	            },
	            onStateChange: _this2.onStateChange,
	            onError: function onError(event) {
	              return _onError(event.data);
	            }
	          }
	        });
	      }, _onError);
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      if (!this.isReady || !this.player.playVideo) return;
	      this.player.playVideo();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      if (!this.isReady || !this.player.pauseVideo) return;
	      this.player.pauseVideo();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      if (!this.isReady || !this.player.stopVideo) return;
	      this.player.stopVideo();
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(YouTube.prototype.__proto__ || Object.getPrototypeOf(YouTube.prototype), 'seekTo', this).call(this, fraction);
	      if (!this.isReady || !this.player.seekTo) return;
	      this.player.seekTo(this.getDuration() * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      if (!this.isReady || !this.player.setVolume) return;
	      this.player.setVolume(fraction * 100);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady || !this.player.getDuration) return null;
	      return this.player.getDuration();
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady || !this.getDuration()) return null;
	      return this.player.getCurrentTime() / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || !this.player.getVideoLoadedFraction) return null;
	      return this.player.getVideoLoadedFraction();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = {
	        height: '100%',
	        display: this.props.url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('div', { ref: this.ref })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return YouTube;
	}(_Base3['default']);
	
	YouTube.displayName = 'YouTube';
	exports['default'] = YouTube;
	module.exports = exports['default'];

/***/ },
/* 13 */
/***/ function(module, exports) {

	
	module.exports = function load (src, opts, cb) {
	  var head = document.head || document.getElementsByTagName('head')[0]
	  var script = document.createElement('script')
	
	  if (typeof opts === 'function') {
	    cb = opts
	    opts = {}
	  }
	
	  opts = opts || {}
	  cb = cb || function() {}
	
	  script.type = opts.type || 'text/javascript'
	  script.charset = opts.charset || 'utf8';
	  script.async = 'async' in opts ? !!opts.async : true
	  script.src = src
	
	  if (opts.attrs) {
	    setAttributes(script, opts.attrs)
	  }
	
	  if (opts.text) {
	    script.text = '' + opts.text
	  }
	
	  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
	  onend(script, cb)
	
	  // some good legacy browsers (firefox) fail the 'in' detection above
	  // so as a fallback we always set onload
	  // old IE will ignore this and new IE will set onload
	  if (!script.onload) {
	    stdOnEnd(script, cb);
	  }
	
	  head.appendChild(script)
	}
	
	function setAttributes(script, attrs) {
	  for (var attr in attrs) {
	    script.setAttribute(attr, attrs[attr]);
	  }
	}
	
	function stdOnEnd (script, cb) {
	  script.onload = function () {
	    this.onerror = this.onload = null
	    cb(null, script)
	  }
	  script.onerror = function () {
	    // this.onload = null here is necessary
	    // because even IE9 works not like others
	    this.onerror = this.onload = null
	    cb(new Error('Failed to load ' + this.src), script)
	  }
	}
	
	function ieOnEnd (script, cb) {
	  script.onreadystatechange = function () {
	    if (this.readyState != 'complete' && this.readyState != 'loaded') return
	    this.onreadystatechange = null
	    cb(null, script) // there is no way to catch loading errors in IE8
	  }
	}


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _props2 = __webpack_require__(11);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SEEK_ON_PLAY_EXPIRY = 5000;
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Base);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Base.__proto__ || Object.getPrototypeOf(Base)).call.apply(_ref, [this].concat(args))), _this), _this.isReady = false, _this.startOnPlay = true, _this.durationOnPlay = false, _this.seekOnPlay = null, _this.onPlay = function () {
	      var _this$props = _this.props;
	      var volume = _this$props.volume;
	      var onStart = _this$props.onStart;
	      var onPlay = _this$props.onPlay;
	      var onDuration = _this$props.onDuration;
	
	      if (_this.startOnPlay) {
	        _this.setVolume(volume);
	        onStart();
	        _this.startOnPlay = false;
	      }
	      onPlay();
	      if (_this.seekOnPlay) {
	        _this.seekTo(_this.seekOnPlay);
	        _this.seekOnPlay = null;
	      }
	      if (_this.durationOnPlay) {
	        onDuration(_this.getDuration());
	        _this.durationOnPlay = false;
	      }
	    }, _this.onReady = function () {
	      var _this$props2 = _this.props;
	      var onReady = _this$props2.onReady;
	      var playing = _this$props2.playing;
	      var onDuration = _this$props2.onDuration;
	
	      _this.isReady = true;
	      onReady();
	      if (playing || _this.preloading) {
	        _this.preloading = false;
	        if (_this.loadOnReady) {
	          _this.load(_this.loadOnReady);
	          _this.loadOnReady = null;
	        } else {
	          _this.play();
	        }
	      }
	      var duration = _this.getDuration();
	      if (duration) {
	        onDuration(duration);
	      } else {
	        _this.durationOnPlay = true;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Base, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var url = this.props.url;
	
	      this.mounted = true;
	      if (url) {
	        this.load(url);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	      this.mounted = false;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props;
	      var url = _props.url;
	      var playing = _props.playing;
	      var volume = _props.volume;
	      // Invoke player methods based on incoming props
	
	      if (url !== nextProps.url && nextProps.url) {
	        this.seekOnPlay = null;
	        this.startOnPlay = true;
	        this.load(nextProps.url);
	      } else if (url && !nextProps.url) {
	        this.stop();
	        clearTimeout(this.updateTimeout);
	      } else if (!playing && nextProps.playing) {
	        this.play();
	      } else if (playing && !nextProps.playing) {
	        this.pause();
	      } else if (volume !== nextProps.volume) {
	        this.setVolume(nextProps.volume);
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.url !== nextProps.url;
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      var _this2 = this;
	
	      // When seeking before player is ready, store value and seek later
	      if (!this.isReady && fraction !== 0) {
	        this.seekOnPlay = fraction;
	        setTimeout(function () {
	          _this2.seekOnPlay = null;
	        }, SEEK_ON_PLAY_EXPIRY);
	      }
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	Base.propTypes = _props2.propTypes;
	Base.defaultProps = _props2.defaultProps;
	exports['default'] = Base;
	module.exports = exports['default'];

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseStartTime = parseStartTime;
	var MATCH_START_QUERY = /[\?&#](?:start|t)=([0-9hms]+)/;
	var MATCH_START_STAMP = /(\d+)(h|m|s)/g;
	var MATCH_NUMERIC = /^\d+$/;
	
	// Parse YouTube URL for a start time param, ie ?t=1h14m30s
	// and return the start time in seconds
	function parseStartTime(url) {
	  var match = url.match(MATCH_START_QUERY);
	  if (match) {
	    var stamp = match[1];
	    if (stamp.match(MATCH_START_STAMP)) {
	      return parseStartStamp(stamp);
	    }
	    if (MATCH_NUMERIC.test(stamp)) {
	      return parseInt(stamp, 10);
	    }
	  }
	  return 0;
	}
	
	function parseStartStamp(stamp) {
	  var seconds = 0;
	  var array = MATCH_START_STAMP.exec(stamp);
	  while (array !== null) {
	    var _array = array;
	
	    var _array2 = _slicedToArray(_array, 3);
	
	    var count = _array2[1];
	    var period = _array2[2];
	
	    if (period === 'h') seconds += parseInt(count, 10) * 60 * 60;
	    if (period === 'm') seconds += parseInt(count, 10) * 60;
	    if (period === 's') seconds += parseInt(count, 10);
	    array = MATCH_START_STAMP.exec(stamp);
	  }
	  return seconds;
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fetchJsonp = __webpack_require__(17);
	
	var _fetchJsonp2 = _interopRequireDefault(_fetchJsonp);
	
	var _FilePlayer2 = __webpack_require__(18);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	var _props3 = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = '//api.soundcloud.com/resolve.json';
	var MATCH_URL = /^https?:\/\/(soundcloud.com|snd.sc)\/([a-z0-9-_]+\/[a-z0-9-_]+)$/;
	
	var songData = {}; // Cache song data requests
	
	var SoundCloud = function (_FilePlayer) {
	  _inherits(SoundCloud, _FilePlayer);
	
	  function SoundCloud() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SoundCloud);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SoundCloud.__proto__ || Object.getPrototypeOf(SoundCloud)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      image: null
	    }, _this.clientId = _this.props.soundcloudConfig.clientId || _props3.defaultProps.soundcloudConfig.clientId, _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SoundCloud, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return _get(SoundCloud.prototype.__proto__ || Object.getPrototypeOf(SoundCloud.prototype), 'shouldComponentUpdate', this).call(this, nextProps, nextState) || this.state.image !== nextState.image;
	    }
	  }, {
	    key: 'getSongData',
	    value: function getSongData(url) {
	      var _this2 = this;
	
	      if (songData[url]) {
	        return Promise.resolve(songData[url]);
	      }
	      return (0, _fetchJsonp2['default'])(RESOLVE_URL + '?url=' + url + '&client_id=' + this.clientId).then(function (response) {
	        if (response.ok) {
	          songData[url] = response.json();
	          return songData[url];
	        } else {
	          _this2.props.onError(new Error('SoundCloud track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this3 = this;
	
	      var _props = this.props;
	      var soundcloudConfig = _props.soundcloudConfig;
	      var onError = _props.onError;
	
	      this.stop();
	      this.getSongData(url).then(function (data) {
	        if (!_this3.mounted) return;
	        if (!data.streamable) {
	          onError(new Error('SoundCloud track is not streamable'));
	          return;
	        }
	        var image = data.artwork_url || data.user.avatar_url;
	        if (image && soundcloudConfig.showArtwork) {
	          _this3.setState({ image: image.replace('-large', '-t500x500') });
	        }
	        _this3.player.src = data.stream_url + '?client_id=' + _this3.clientId;
	      }, onError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var url = _props2.url;
	      var loop = _props2.loop;
	      var controls = _props2.controls;
	
	      var style = {
	        display: url ? 'block' : 'none',
	        height: '100%',
	        backgroundImage: this.state.image ? 'url(' + this.state.image + ')' : null,
	        backgroundSize: 'cover',
	        backgroundPosition: 'center'
	      };
	      return _react2['default'].createElement(
	        'div',
	        { style: style },
	        _react2['default'].createElement('audio', {
	          ref: this.ref,
	          type: 'audio/mpeg',
	          preload: 'auto',
	          style: {
	            width: '100%',
	            height: '100%'
	          },
	          controls: controls,
	          loop: loop
	        })
	      );
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return SoundCloud;
	}(_FilePlayer3['default']);
	
	SoundCloud.displayName = 'SoundCloud';
	exports['default'] = SoundCloud;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
	    factory(exports, module);
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, mod);
	    global.fetchJsonp = mod.exports;
	  }
	})(this, function (exports, module) {
	  'use strict';
	
	  var defaultOptions = {
	    timeout: 5000,
	    jsonpCallback: 'callback',
	    jsonpCallbackFunction: null
	  };
	
	  function generateCallbackFunction() {
	    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
	  }
	
	  // Known issue: Will throw 'Uncaught ReferenceError: callback_*** is not defined'
	  // error if request timeout
	  function clearFunction(functionName) {
	    // IE8 throws an exception when you try to delete a property on window
	    // http://stackoverflow.com/a/1824228/751089
	    try {
	      delete window[functionName];
	    } catch (e) {
	      window[functionName] = undefined;
	    }
	  }
	
	  function removeScript(scriptId) {
	    var script = document.getElementById(scriptId);
	    document.getElementsByTagName('head')[0].removeChild(script);
	  }
	
	  function fetchJsonp(_url) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // to avoid param reassign
	    var url = _url;
	    var timeout = options.timeout || defaultOptions.timeout;
	    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;
	
	    var timeoutId = undefined;
	
	    return new Promise(function (resolve, reject) {
	      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
	      var scriptId = jsonpCallback + '_' + callbackFunction;
	
	      window[callbackFunction] = function (response) {
	        resolve({
	          ok: true,
	          // keep consistent with fetch API
	          json: function json() {
	            return Promise.resolve(response);
	          }
	        });
	
	        if (timeoutId) clearTimeout(timeoutId);
	
	        removeScript(scriptId);
	
	        clearFunction(callbackFunction);
	      };
	
	      // Check if the user set their own params, and if not add a ? to start a list of params
	      url += url.indexOf('?') === -1 ? '?' : '&';
	
	      var jsonpScript = document.createElement('script');
	      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
	      jsonpScript.id = scriptId;
	      document.getElementsByTagName('head')[0].appendChild(jsonpScript);
	
	      timeoutId = setTimeout(function () {
	        reject(new Error('JSONP request to ' + url + ' timed out'));
	
	        clearFunction(callbackFunction);
	        removeScript(scriptId);
	      }, timeout);
	    });
	  }
	
	  // export as global function
	  /*
	  let local;
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	  local.fetchJsonp = fetchJsonp;
	  */
	
	  module.exports = fetchJsonp;
	});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Base2 = __webpack_require__(14);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AUDIO_EXTENSIONS = /\.(mp3|wav|m4a)($|\?)/i;
	
	var FilePlayer = function (_Base) {
	  _inherits(FilePlayer, _Base);
	
	  function FilePlayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FilePlayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilePlayer.__proto__ || Object.getPrototypeOf(FilePlayer)).call.apply(_ref, [this].concat(args))), _this), _this.ref = function (player) {
	      _this.player = player;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FilePlayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var onPause = _props.onPause;
	      var onEnded = _props.onEnded;
	      var onError = _props.onError;
	
	      this.player.addEventListener('canplay', this.onReady);
	      this.player.addEventListener('play', this.onPlay);
	      this.player.addEventListener('pause', function () {
	        if (_this2.mounted) {
	          onPause();
	        }
	      });
	      this.player.addEventListener('ended', onEnded);
	      this.player.addEventListener('error', onError);
	      this.player.setAttribute('webkit-playsinline', '');
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props;
	      var onPause = _props2.onPause;
	      var onEnded = _props2.onEnded;
	      var onError = _props2.onError;
	
	      this.player.removeEventListener('canplay', this.onReady);
	      this.player.removeEventListener('play', this.onPlay);
	      this.player.removeEventListener('pause', onPause);
	      this.player.removeEventListener('ended', onEnded);
	      this.player.removeEventListener('error', onError);
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      this.player.src = url;
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.player.play();
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.player.pause();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.player.removeAttribute('src');
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(FilePlayer.prototype.__proto__ || Object.getPrototypeOf(FilePlayer.prototype), 'seekTo', this).call(this, fraction);
	      this.player.currentTime = this.getDuration() * fraction;
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.player.volume = fraction;
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      if (!this.isReady) return null;
	      return this.player.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      if (!this.isReady) return null;
	      return this.player.currentTime / this.getDuration();
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      if (!this.isReady || this.player.buffered.length === 0) return null;
	      return this.player.buffered.end(0) / this.getDuration();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var url = _props3.url;
	      var loop = _props3.loop;
	      var controls = _props3.controls;
	      var fileConfig = _props3.fileConfig;
	
	      var Media = AUDIO_EXTENSIONS.test(url) ? 'audio' : 'video';
	      var style = {
	        width: '100%',
	        height: '100%',
	        display: url ? 'block' : 'none'
	      };
	      return _react2['default'].createElement(Media, _extends({
	        ref: this.ref,
	        style: style,
	        preload: 'auto',
	        controls: controls,
	        loop: loop
	      }, fileConfig.attributes));
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return true;
	    }
	  }]);
	
	  return FilePlayer;
	}(_Base3['default']);
	
	FilePlayer.displayName = 'FilePlayer';
	exports['default'] = FilePlayer;
	module.exports = exports['default'];

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _queryString = __webpack_require__(20);
	
	var _Base2 = __webpack_require__(14);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IFRAME_SRC = 'https://player.vimeo.com/video/';
	var MATCH_URL = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
	var MATCH_MESSAGE_ORIGIN = /^https?:\/\/player.vimeo.com/;
	var BLANK_VIDEO_URL = 'https://vimeo.com/127250231';
	var DEFAULT_IFRAME_PARAMS = {
	  api: 1,
	  autoplay: 0,
	  badge: 0,
	  byline: 0,
	  fullscreen: 1,
	  portrait: 0,
	  title: 0
	};
	
	var Vimeo = function (_Base) {
	  _inherits(Vimeo, _Base);
	
	  function Vimeo() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Vimeo);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Vimeo.__proto__ || Object.getPrototypeOf(Vimeo)).call.apply(_ref, [this].concat(args))), _this), _this.onMessage = function (e) {
	      if (!MATCH_MESSAGE_ORIGIN.test(e.origin)) return;
	      _this.origin = _this.origin || e.origin;
	      var data = JSON.parse(e.data);
	      if (data.event === 'ready') {
	        _this.postMessage('getDuration');
	        _this.postMessage('addEventListener', 'playProgress');
	        _this.postMessage('addEventListener', 'loadProgress');
	        _this.postMessage('addEventListener', 'play');
	        _this.postMessage('addEventListener', 'pause');
	        _this.postMessage('addEventListener', 'finish');
	      }
	      if (data.event === 'playProgress') _this.fractionPlayed = data.data.percent;
	      if (data.event === 'loadProgress') _this.fractionLoaded = data.data.percent;
	      if (data.event === 'play') _this.onPlay();
	      if (data.event === 'pause') _this.props.onPause();
	      if (data.event === 'finish') _this.onEnded();
	      if (data.method === 'getDuration') {
	        _this.duration = data.value; // Store for use later
	        _this.onReady();
	      }
	    }, _this.onEnded = function () {
	      var _this$props = _this.props;
	      var loop = _this$props.loop;
	      var onEnded = _this$props.onEnded;
	
	      if (loop) {
	        _this.seekTo(0);
	      }
	      onEnded();
	    }, _this.postMessage = function (method, value) {
	      if (!_this.origin) return;
	      var data = JSON.stringify({ method: method, value: value });
	      return _this.iframe.contentWindow && _this.iframe.contentWindow.postMessage(data, _this.origin);
	    }, _this.ref = function (iframe) {
	      _this.iframe = iframe;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Vimeo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props;
	      var url = _props.url;
	      var vimeoConfig = _props.vimeoConfig;
	
	      window.addEventListener('message', this.onMessage, false);
	
	      if (!url && vimeoConfig.preload) {
	        this.preloading = true;
	        this.load(BLANK_VIDEO_URL);
	      }
	
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentDidMount', this).call(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.onMessage, false);
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'componentWillUnmount', this).call(this);
	    }
	  }, {
	    key: 'getIframeParams',
	    value: function getIframeParams() {
	      return _extends({}, DEFAULT_IFRAME_PARAMS, this.props.vimeoConfig.iframeParams);
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var id = url.match(MATCH_URL)[3];
	      this.iframe.src = IFRAME_SRC + id + '?' + (0, _queryString.stringify)(this.getIframeParams());
	    }
	  }, {
	    key: 'play',
	    value: function play() {
	      this.postMessage('play');
	    }
	  }, {
	    key: 'pause',
	    value: function pause() {
	      this.postMessage('pause');
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.iframe.src = '';
	    }
	  }, {
	    key: 'seekTo',
	    value: function seekTo(fraction) {
	      _get(Vimeo.prototype.__proto__ || Object.getPrototypeOf(Vimeo.prototype), 'seekTo', this).call(this, fraction);
	      this.postMessage('seekTo', this.duration * fraction);
	    }
	  }, {
	    key: 'setVolume',
	    value: function setVolume(fraction) {
	      this.postMessage('setVolume', fraction);
	    }
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      return this.duration;
	    }
	  }, {
	    key: 'getFractionPlayed',
	    value: function getFractionPlayed() {
	      return this.fractionPlayed || null;
	    }
	  }, {
	    key: 'getFractionLoaded',
	    value: function getFractionLoaded() {
	      return this.fractionLoaded || null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _getIframeParams = this.getIframeParams();
	
	      var fullscreen = _getIframeParams.fullscreen;
	
	      var style = {
	        display: this.props.url ? 'block' : 'none',
	        width: '100%',
	        height: '100%'
	      };
	      return _react2['default'].createElement('iframe', {
	        ref: this.ref,
	        frameBorder: '0',
	        style: style,
	        allowFullScreen: fullscreen
	      });
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vimeo;
	}(_Base3['default']);
	
	Vimeo.displayName = 'Vimeo';
	exports['default'] = Vimeo;
	module.exports = exports['default'];

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(21);
	var objectAssign = __webpack_require__(22);
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (ret[key] === undefined) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
		});
	
		return ret;
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true
		};
	
		opts = objectAssign(defaults, opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					if (val2 === null) {
						result.push(encode(key, opts));
					} else {
						result.push(encode(key, opts) + '=' + encode(val2, opts));
					}
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(227);

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(4);

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(18);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.streamable.com/videos/';
	var MATCH_URL = /^https?:\/\/streamable.com\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Streamable = function (_FilePlayer) {
	  _inherits(Streamable, _FilePlayer);
	
	  function Streamable() {
	    _classCallCheck(this, Streamable);
	
	    return _possibleConstructorReturn(this, (Streamable.__proto__ || Object.getPrototypeOf(Streamable)).apply(this, arguments));
	  }
	
	  _createClass(Streamable, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Streamable track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.files.mp4.url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Streamable;
	}(_FilePlayer3['default']);
	
	Streamable.displayName = 'Streamable';
	exports['default'] = Streamable;
	module.exports = exports['default'];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _FilePlayer2 = __webpack_require__(18);
	
	var _FilePlayer3 = _interopRequireDefault(_FilePlayer2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RESOLVE_URL = 'https://api.vid.me/videoByUrl/';
	var MATCH_URL = /^https?:\/\/vid.me\/([a-z0-9]+)$/;
	
	var cache = {}; // Cache song data requests
	
	var Vidme = function (_FilePlayer) {
	  _inherits(Vidme, _FilePlayer);
	
	  function Vidme() {
	    _classCallCheck(this, Vidme);
	
	    return _possibleConstructorReturn(this, (Vidme.__proto__ || Object.getPrototypeOf(Vidme)).apply(this, arguments));
	  }
	
	  _createClass(Vidme, [{
	    key: 'getData',
	    value: function getData(url) {
	      var onError = this.props.onError;
	
	      var id = url.match(MATCH_URL)[1];
	      if (cache[id]) {
	        return Promise.resolve(cache[id]);
	      }
	      return window.fetch(RESOLVE_URL + id).then(function (response) {
	        if (response.status === 200) {
	          cache[id] = response.json();
	          return cache[id];
	        } else {
	          onError(new Error('Vidme track could not be resolved'));
	        }
	      });
	    }
	  }, {
	    key: 'load',
	    value: function load(url) {
	      var _this2 = this;
	
	      var onError = this.props.onError;
	
	      this.stop();
	      this.getData(url).then(function (data) {
	        if (!_this2.mounted) return;
	        _this2.player.src = data.video.complete_url;
	      }, onError);
	    }
	  }], [{
	    key: 'canPlay',
	    value: function canPlay(url) {
	      return MATCH_URL.test(url);
	    }
	  }]);
	
	  return Vidme;
	}(_FilePlayer3['default']);
	
	Vidme.displayName = 'Vidme';
	exports['default'] = Vidme;
	module.exports = exports['default'];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var Map_1 = __webpack_require__(26);
	var $ = __webpack_require__(7);
	var heading;
	var cache;
	function anim(data) {
	    var animate = function (current) {
	        $('.heading .cover').animate({ opacity: 0 }, function () {
	            $('.heading .cover').css({ background: 'url(/assets/heading/' + data[current] + ')' });
	            $('.heading .cover').animate({ opacity: 1 });
	        });
	    };
	    var current = 0, changeHeadingBackground = function () {
	        animate(current);
	        if (++current >= data.length) {
	            current = 0;
	        }
	    };
	    var interval = setInterval(changeHeadingBackground, 5000);
	    $('.heading .cover').on('click', '.leftArrow, .rightArrow', function (e) {
	        e.preventDefault();
	        clearInterval(interval);
	        if ($(this).hasClass('leftArrow')) {
	            current--;
	            if (current < 0) {
	                current = data.length - 1;
	            }
	        }
	        else if ($(this).hasClass('rightArrow')) {
	            current++;
	            if (current >= data.length) {
	                current = 0;
	            }
	        }
	        animate(current);
	    });
	    return interval;
	}
	var AboutConference = (function (_super) {
	    __extends(AboutConference, _super);
	    function AboutConference() {
	        _super.apply(this, arguments);
	    }
	    AboutConference.prototype.componentDidMount = function () {
	        var _this = this;
	        if (!heading) {
	            $.getJSON('/assets/heading.json', function (data) {
	                cache = data.map(function (image) {
	                    var cache = new Image();
	                    cache.src = helpers_1.assets('/heading/' + image);
	                    return cache;
	                });
	                _this.animationInterval = anim(data);
	            });
	        }
	        else {
	            this.animationInterval = anim(heading);
	        }
	    };
	    AboutConference.prototype.componentWillUnmount = function () {
	        clearInterval(this.animationInterval);
	    };
	    AboutConference.prototype.render = function () {
	        return (React.createElement("section", {className: "heading"}, 
	            React.createElement("a", {name: "about"}), 
	            React.createElement("div", {className: "cover", style: { opacity: 1, background: "url(" + helpers_1.assets("/heading/5.jpg") + ")" }}, 
	                React.createElement("a", {href: "#", className: "leftArrow"}), 
	                React.createElement("a", {href: "#", className: "rightArrow"})), 
	            React.createElement("div", {className: "desc"}, 
	                React.createElement("h1", null, "Loudhead - это самое громкое событие года среди настоящих любителей звука."), 
	                React.createElement("p", null, "Ежегодно компания Doctorhead собирает в одном месте самых лучших производителей персонального аудио: наушников, плееров, усилителей - и сотни ценителей хорошего звука. Loudhead - это уникальная возможность не только протестировать большую часть самого лучшего  портативного аудио, представленного на рынке и легендарные раритетные модели, но и продемонстрировать собственные системы и аудио-компоненты, обменяться мнениями и новостями, и отлично провести время в компании единомышленников.")), 
	            React.createElement("div", {className: "icons"}, 
	                React.createElement("a", {href: "http://vk.com/share.php?url=http%3A%2F%2Floudhead.ru%2F%3Fvk", target: "_blank", className: "icon icon-vk"}), 
	                React.createElement("a", {href: "http://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Floudhead.ru%2F%3Ffb", target: "_blank", className: "icon icon-fb"}), 
	                React.createElement("a", {href: "http://twitter.com/share?url=http%3A%2F%2Floudhead.ru%2F%3Ftw", target: "_blank", className: "icon icon-tw"})), 
	            React.createElement(Map_1.Map, null)));
	    };
	    return AboutConference;
	}(React.Component));
	exports.AboutConference = AboutConference;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var Map = (function (_super) {
	    __extends(Map, _super);
	    function Map() {
	        _super.apply(this, arguments);
	    }
	    Map.prototype.componentDidMount = function () {
	        var script = document.createElement("script");
	        var container = document.getElementById('heading-map');
	        script.src = "https://api-maps.yandex.ru/services/constructor/1.0/js/?sid=2Lu15pHutQ7T-n_ixYJq9Nw2YbzPpYFv&amp;width=100%&amp;height=400&amp;lang=ru_RU&amp;sourceType=constructor&amp;scroll=true";
	        script.async = true;
	        script.charset = 'UTF-8';
	        container.appendChild(script);
	    };
	    Map.prototype.render = function () {
	        return (React.createElement("section", {className: "sony-map"}, 
	            React.createElement("div", {id: "heading-map", style: { width: "100%", height: '400px' }})
	        ));
	    };
	    return Map;
	}(React.Component));
	exports.Map = Map;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var $ = __webpack_require__(7);
	window['$'] = $;
	window['jQuery'] = $;
	__webpack_require__(28);
	$(function () {
	    $.fancybox.defaults.nextClick = true;
	    $.fancybox.defaults.helpers.overlay = { nextClick: true, closeClick: false };
	});
	$(window).load(function () {
	    var images = {};
	    $.getJSON('/assets/images.json?3', function (data) {
	        for (var key in data) {
	            if (data.hasOwnProperty(key)) {
	                images[key] = [];
	                data[key].forEach(function (row) {
	                    images[key].push({ href: '/images/' + key + '/' + row.replace('{size}', 'big') });
	                });
	            }
	        }
	        $(document.body).on('click', 'section.images ul li', function (e) {
	            var item = $(this), id = item.data('galleryId');
	            e.preventDefault();
	            if (id && images[id].length > 0) {
	                $.fancybox.open(images[id], { index: $(this).data('index') - 1 });
	            }
	        });
	    });
	});
	var GalleryConference = (function (_super) {
	    __extends(GalleryConference, _super);
	    function GalleryConference() {
	        _super.apply(this, arguments);
	    }
	    GalleryConference.prototype.render = function () {
	        return (React.createElement("section", {className: "images"}, 
	            React.createElement("a", {name: "images"}), 
	            React.createElement("ul", null, 
	                React.createElement("li", {"data-gallery-id": "2012"}, 
	                    React.createElement("h4", null, "LOUDHEAD 2012"), 
	                    React.createElement("a", {href: "#"}, 
	                        React.createElement("img", {src: "/images/2012/small/1.jpg", className: "img-responsive"})
	                    )), 
	                React.createElement("li", {"data-gallery-id": "2014"}, 
	                    React.createElement("h4", null, "LOUDHEAD 2014"), 
	                    React.createElement("a", {href: "#"}, 
	                        React.createElement("img", {src: "/images/2014/small/6.jpg", className: "img-responsive"})
	                    )), 
	                React.createElement("li", {"data-gallery-id": "2016"}, 
	                    React.createElement("h4", null, "LOUDHEAD 2016"), 
	                    React.createElement("a", {href: "#"}, 
	                        React.createElement("img", {src: "/images/2016/small/11.jpg", className: "img-responsive"})
	                    )))));
	    };
	    return GalleryConference;
	}(React.Component));
	exports.GalleryConference = GalleryConference;


/***/ },
/* 28 */
/***/ function(module, exports) {

	/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
	(function(r,G,f,v){var J=f("html"),n=f(r),p=f(G),b=f.fancybox=function(){b.open.apply(this,arguments)},I=navigator.userAgent.match(/msie/i),B=null,s=G.createTouch!==v,t=function(a){return a&&a.hasOwnProperty&&a instanceof f},q=function(a){return a&&"string"===f.type(a)},E=function(a){return q(a)&&0<a.indexOf("%")},l=function(a,d){var e=parseInt(a,10)||0;d&&E(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},w=function(a,b){return l(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20,
	width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!s,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"},
	keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+
	(I?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0,
	openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"elastic",nextSpeed:250,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"elastic",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1,
	isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=t(a)?f(a).get():[a]),f.each(a,function(e,c){var k={},g,h,j,m,l;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),t(c)?(k={href:c.data("fancybox-href")||c.attr("href"),title:c.data("fancybox-title")||c.attr("title"),isDom:!0,element:c},f.metadata&&f.extend(!0,k,
	c.metadata())):k=c);g=d.href||k.href||(q(c)?c:null);h=d.title!==v?d.title:k.title||"";m=(j=d.content||k.content)?"html":d.type||k.type;!m&&k.isDom&&(m=c.data("fancybox-type"),m||(m=(m=c.prop("class").match(/fancybox\.(\w+)/))?m[1]:null));q(g)&&(m||(b.isImage(g)?m="image":b.isSWF(g)?m="swf":"#"===g.charAt(0)?m="inline":q(c)&&(m="html",j=c)),"ajax"===m&&(l=g.split(/\s+/,2),g=l.shift(),l=l.shift()));j||("inline"===m?g?j=f(q(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):k.isDom&&(j=c):"html"===m?j=g:!m&&(!g&&
	k.isDom)&&(m="inline",j=c));f.extend(k,{href:g,type:m,content:j,title:h,selector:l});a[e]=k}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==v&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1!==b.trigger("onCancel")&&(b.hideLoading(),b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),b.coming=null,b.current||
	b._afterZoomOut(a))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(!b.isOpen||!0===a?(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut()):(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&(b.player.timer=
	setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};if(!0===a||!b.player.isActive&&!1!==a){if(b.current&&(b.current.loop||b.current.index<b.group.length-1))b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")}else c()},next:function(a){var d=b.current;d&&(q(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=b.current;
	d&&(q(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=l(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==v&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,k;c&&(k=b._getPosition(d),a&&"scroll"===a.type?(delete k.position,c.stop(!0,!0).animate(k,200)):(c.css(k),e.pos=f.extend({},e.dim,k)))},update:function(a){var d=
	a&&a.type,e=!d||"orientationchange"===d;e&&(clearTimeout(B),B=null);b.isOpen&&!B&&(B=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),B=null)},e&&!s?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,s&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),b.trigger("onUpdate")),
	b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){if(27===(a.which||a.keyCode))a.preventDefault(),b.cancel()});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}))},getViewport:function(){var a=b.current&&b.current.locked||!1,d={x:n.scrollLeft(),
	y:n.scrollTop()};a?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=s&&r.innerWidth?r.innerWidth:n.width(),d.h=s&&r.innerHeight?r.innerHeight:n.height());return d},unbindEvents:function(){b.wrap&&t(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(n.bind("orientationchange.fb"+(s?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=e.which||e.keyCode,k=e.target||e.srcElement;
	if(27===c&&b.coming)return!1;!e.ctrlKey&&(!e.altKey&&!e.shiftKey&&!e.metaKey&&(!k||!k.type&&!f(k).is("[contenteditable]")))&&f.each(d,function(d,k){if(1<a.group.length&&k[c]!==v)return b[d](k[c]),e.preventDefault(),!1;if(-1<f.inArray(c,k))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,k,g){for(var h=f(d.target||null),j=!1;h.length&&!j&&!h.is(".fancybox-skin")&&!h.is(".fancybox-wrap");)j=h[0]&&!(h[0].style.overflow&&"hidden"===h[0].style.overflow)&&
	(h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();if(0!==c&&!j&&1<b.group.length&&!a.canShrink){if(0<g||0<k)b.prev(0<g?"down":"left");else if(0>g||0>k)b.next(0>g?"up":"right");d.preventDefault()}}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0,
	{},b.helpers[d].defaults,e),c)});p.trigger(a)}},isImage:function(a){return q(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return q(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=l(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1,
	mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio=
	!0);"iframe"===c&&s&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(s?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,w(d.padding[a]))});b.trigger("onReady");if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href");
	"image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload=
	this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",s?"auto":a.iframe.scrolling).attr("src",a.href);
	f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);s||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload,
	e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,k,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e=a.content;c=a.type;k=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin,
	outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):t(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",!1)}));break;case "image":e=a.tpl.image.replace("{href}",
	g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}(!t(e)||!e.parent().is(a.inner))&&a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow","yes"===k?"scroll":
	"no"===k?"hidden":k);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(b.isOpened){if(d.prevMethod)b.transitions[d.prevMethod]()}else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,k=b.skin,g=b.inner,h=b.current,c=h.width,j=h.height,m=h.minWidth,u=h.minHeight,n=h.maxWidth,p=h.maxHeight,s=h.scrolling,q=h.scrollOutside?
	h.scrollbarWidth:0,x=h.margin,y=l(x[1]+x[3]),r=l(x[0]+x[2]),v,z,t,C,A,F,B,D,H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x=l(k.outerWidth(!0)-k.width());v=l(k.outerHeight(!0)-k.height());z=y+x;t=r+v;C=E(c)?(a.w-z)*l(c)/100:c;A=E(j)?(a.h-t)*l(j)/100:j;if("iframe"===h.type){if(H=h.content,h.autoHeight&&1===H.data("ready"))try{H[0].contentWindow.document.location&&(g.width(C).height(9999),F=H.contents().find("body"),q&&F.css("overflow-x","hidden"),A=F.outerHeight(!0))}catch(G){}}else if(h.autoWidth||
	h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(C),h.autoHeight||g.height(A),h.autoWidth&&(C=g.width()),h.autoHeight&&(A=g.height()),g.removeClass("fancybox-tmp");c=l(C);j=l(A);D=C/A;m=l(E(m)?l(m,"w")-z:m);n=l(E(n)?l(n,"w")-z:n);u=l(E(u)?l(u,"h")-t:u);p=l(E(p)?l(p,"h")-t:p);F=n;B=p;h.fitToView&&(n=Math.min(a.w-z,n),p=Math.min(a.h-t,p));z=a.w-y;r=a.h-r;h.aspectRatio?(c>n&&(c=n,j=l(c/D)),j>p&&(j=p,c=l(j*D)),c<m&&(c=m,j=l(c/D)),j<u&&(j=u,c=l(j*D))):(c=Math.max(m,Math.min(c,n)),h.autoHeight&&
	"iframe"!==h.type&&(g.width(c),j=g.height()),j=Math.max(u,Math.min(j,p)));if(h.fitToView)if(g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height(),h.aspectRatio)for(;(a>z||y>r)&&(c>m&&j>u)&&!(19<d++);)j=Math.max(u,Math.min(p,j-10)),c=l(j*D),c<m&&(c=m,j=l(c/D)),c>n&&(c=n,j=l(c/D)),g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height();else c=Math.max(m,Math.min(c,c-(a-z))),j=Math.max(u,Math.min(j,j-(y-r)));q&&("auto"===s&&j<A&&c+x+q<z)&&(c+=q);g.width(c).height(j);e.width(c+x);a=e.width();
	y=e.height();e=(a>z||y>r)&&c>m&&j>u;c=h.aspectRatio?c<F&&j<B&&c<C&&j<A:(c<F||j<B)&&(c<C||j<A);f.extend(h,{dim:{width:w(a),height:w(y)},origWidth:C,origHeight:A,canShrink:e,canExpand:c,wPadding:x,hPadding:v,wrapSpace:y-k.outerHeight(!0),skinSpace:k.height()-j});!H&&(h.autoHeight&&j>u&&j<p&&!c)&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",top:c[0],left:c[3]};d.autoCenter&&d.fixed&&
	!a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=w(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=w(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&(b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){!f(d.target).is("a")&&!f(d.target).parent().is("a")&&(d.preventDefault(),
	b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),!a.loop&&a.index===a.group.length-1?b.play(!1):b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play()))},_afterZoomOut:function(a){a=
	a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,j=a.wPadding,m=b.getViewport();!e&&(a.isDom&&d.is(":visible"))&&(e=d.find("img:first"),e.length||(e=d));t(e)?(c=e.offset(),e.is("img")&&(f=e.outerWidth(),g=e.outerHeight())):
	(c.top=m.y+(m.h-g)*a.topRatio,c.left=m.x+(m.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=m.y,c.left-=m.x;return c={top:w(c.top-h*a.topRatio),left:w(c.left-j*a.leftRatio),width:w(f+j),height:w(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](l("width"===f?c:c-g*e)),b.inner[f](l("width"===
	f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,k=f.extend({opacity:1},d);delete k.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(k,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&(c.opacity=0.1));b.wrap.animate(c,
	{duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=w(l(e[g])-200),c[g]="+=200px"):(e[g]=w(l(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},changeOut:function(){var a=
	b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!s,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){a=f.extend({},this.defaults,a);this.overlay&&this.close();this.overlay=
	f('<div class="fancybox-overlay"></div>').appendTo(b.coming?b.coming.parent:a.parent);this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(n.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive?
	b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){var a,b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),a=n.scrollTop(),b=n.scrollLeft(),this.el.removeClass("fancybox-lock"),n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");I?(b=Math.max(G.documentElement.offsetWidth,G.body.offsetWidth),
	p.width()>b&&(a=p.width())):p.width()>n.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&(this.fixed&&b.fixed)&&(e||(this.margin=p.height()>n.height()?f("html").css("margin-right").replace("px",""):!1),b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){var e,c;b.locked&&(!1!==this.margin&&(f("*").filter(function(){return"fixed"===
	f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin")),e=n.scrollTop(),c=n.scrollLeft(),this.el.addClass("fancybox-lock"),n.scrollTop(e).scrollLeft(c));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",position:"bottom"},beforeShow:function(a){var d=
	b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(q(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),I&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(l(d.css("margin-bottom")))}d["top"===a.position?"prependTo":"appendTo"](c)}}};f.fn.fancybox=function(a){var d,
	e=f(this),c=this.selector||"",k=function(g){var h=f(this).blur(),j=d,k,l;!g.ctrlKey&&(!g.altKey&&!g.shiftKey&&!g.metaKey)&&!h.is(".fancybox-wrap")&&(k=a.groupAttr||"data-fancybox-group",l=h.attr(k),l||(k="rel",l=h.get(0)[k]),l&&(""!==l&&"nofollow"!==l)&&(h=c.length?f(c):e,h=h.filter("["+k+'="'+l+'"]'),j=h.index(this)),a.index=j,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;!c||!1===a.live?e.unbind("click.fb-start").bind("click.fb-start",k):p.undelegate(c,"click.fb-start").delegate(c+
	":not('.fancybox-item, .fancybox-nav')","click.fb-start",k);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===v&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});if(f.support.fixedPosition===v){a=f.support;d=f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e=20===
	d[0].offsetTop||15===d[0].offsetTop;d.remove();a.fixedPosition=e}f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(r).width();J.addClass("fancybox-lock-test");d=f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var PressConference = (function (_super) {
	    __extends(PressConference, _super);
	    function PressConference() {
	        _super.apply(this, arguments);
	    }
	    PressConference.prototype.render = function () {
	        return (React.createElement("section", {className: "press"}, 
	            React.createElement("a", {name: "press"}), 
	            React.createElement("ul", null, 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/ixbt.jpg")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/", target: "_blank", className: "pressName"}, "IXBT.COM"), 
	                            React.createElement("a", {href: "http://personalaudio.ru/detail/unikalnaya_vstrecha_lyubiteley_personalnogo_audio_v_moskve/", target: "_blank"}, 
	                                React.createElement("span", null, "Уникальная встреча любителей персонального аудио в Москве!")
	                            ), 
	                            React.createElement("p", null, "Это было великолепное сочетание  невероятно дружелюбной атмосферы самых простых людей и сложной техники. Loudhead, пожалуй лучшее событие в этом году для всех настоящих ценителей хорошего звука.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://www.hi-fi.ru/news/dom/detail/1009490", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/2.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://www.hi-fi.ru/news/dom/detail/1009490", target: "_blank", className: "pressName"}, "Hi-Fi.ru"), 
	                            React.createElement("a", {href: "http://www.hi-fi.ru/news/dom/detail/1009490", target: "_blank"}, 
	                                React.createElement("span", null, "Doctorhead: персональное аудио в Москве")
	                            ), 
	                            React.createElement("p", null, "Для нашей страны это абсолютно новый формат, которому организаторы Loudhead смогли придать свой особенный шарм, выражавшийся в необыкновенно дружелюбной атмосфере при огромном количестве гостей на один квадратный метр.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://www.salonav.com/arch/2014/12/loudhead.htm", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/3.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://www.salonav.com/arch/2014/12/loudhead.htm", target: "_blank", className: "pressName"}, "AudioVideo"), 
	                            React.createElement("a", {href: "http://www.salonav.com/arch/2014/12/loudhead.htm", target: "_blank"}, 
	                                React.createElement("span", null, "НАЕДИНЕ, НО ВМЕСТЕ")
	                            ), 
	                            React.createElement("p", null, 
	                                "«Будем надеяться, что встречи «Loudhead» станут регулярными, а число их участников будет расти – потребность в таком общении огромна, особенно в наши нелёгкие времена...»", 
	                                React.createElement("br", null), 
	                                "Дмитрий Ловковский")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://www.hifinews.ru/article/details/24677.htm", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/4.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://www.hifinews.ru/article/details/24677.htm", target: "_blank", className: "pressName"}, "hifiNews"), 
	                            React.createElement("a", {href: "http://www.hifinews.ru/article/details/24677.htm", target: "_blank"}, 
	                                React.createElement("span", null, "Уникальная встреча в Москве!")
	                            ), 
	                            React.createElement("p", null, "Заходя в наполненный людьми с горящими глазами зал, словно отключался от реальности серой Москвы за дверями выставочного павильона и попадал в рай для аудиофила.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/5.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/", target: "_blank", className: "pressName"}, "Нота Плюс"), 
	                            React.createElement("a", {href: "http://nota.ru/news/loudhead_2014_vstrecha_lyubiteley_personalnogo_audio/", target: "_blank"}, 
	                                React.createElement("span", null, "Благодарим организаторов и всех любителей качественного аудио")
	                            ), 
	                            React.createElement("p", null, "Это одна из самых интересных и насыщенных встреч года по данной тематике!Ну и конечно все участники мероприятия и посетители смогли насладиться качественной музыкой, пообщаться со своими единомышленниками и партнерами, ощутить дух товарищества и поддержку сотен таких же аудио-вундеркиндов как они сами за пинтой приятного эля!  Владислав Шабельский \"Нота Плюс\"")))
	                ))));
	    };
	    return PressConference;
	}(React.Component));
	exports.PressConference = PressConference;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var PressConference2016 = (function (_super) {
	    __extends(PressConference2016, _super);
	    function PressConference2016() {
	        _super.apply(this, arguments);
	    }
	    PressConference2016.prototype.render = function () {
	        return (React.createElement("section", {className: "press"}, 
	            React.createElement("a", {name: "press"}), 
	            React.createElement("h1", null, "Пресса о LOUDHEAD 2016"), 
	            React.createElement("ul", null, 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/djmag.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show", target: "_blank", className: "pressName"}, "DJMAG.RU"), 
	                            React.createElement("a", {href: "http://djmag.ru/galleries/v-moskve-proshla-vystavka-loudhead-audio-show", target: "_blank"}, 
	                                React.createElement("span", null, "В Москве прошла выставка LOUDHEAD audio show!")
	                            ), 
	                            React.createElement("p", null, "В этом году шоу стало заметно больше, и вызвало большой интерес у публики.Павильон все два дня был наполнен людьми, активно и с удовольствием тестирующими наушники плееры и усилители.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://4pda.ru/2016/11/03/328446/", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/4pda.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://4pda.ru/2016/11/03/328446/", target: "_blank", className: "pressName"}, "4PDA.RU"), 
	                            React.createElement("a", {href: "http://4pda.ru/2016/11/03/328446/", target: "_blank"}, 
	                                React.createElement("span", null, "В Москве прошла аудио-выставка Loudhead 2016")
	                            ), 
	                            React.createElement("p", null, "Сотни посетителей выставки смогли одними из первых лично опробовать аудионовинки от именитых брендов, которые ещё даже не поступили в продажу.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://stereo.ru/news/loudhead-2016-results", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/stereo.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://stereo.ru/news/loudhead-2016-results", target: "_blank", className: "pressName"}, "STEREO.RU"), 
	                            React.createElement("a", {href: "http://stereo.ru/news/loudhead-2016-results", target: "_blank"}, 
	                                React.createElement("span", null, "Итоги Loudhead 2016: шотландская арматура, японская щедрость и всеобщая теплота")
	                            ), 
	                            React.createElement("p", null, "Розыгрышей на шоу было действительно немало: буквально каждые полчаса толпы людей собирались возле стендов, чтобы послушать о технологиях и инновациях, а после непременно разыгрывались ценные призы.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://www.3dnews.ru/942061", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/3dnews.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://www.3dnews.ru/942061", target: "_blank", className: "pressName"}, "3DNEWS.RU"), 
	                            React.createElement("a", {href: "http://www.3dnews.ru/942061", target: "_blank"}, 
	                                React.createElement("span", null, "LOUDHEAD 2016: праздник качественного звука")
	                            ), 
	                            React.createElement("p", null, "Для одних данное мероприятие — это хорошая возможность попробовать на слух как уже зарекомендовавшие себя на рынке решения, так и ещё не поступившие в продажу новинки; для других — шанс продемонстрировать собственные системы, пообщаться с единомышленниками.")))
	                ), 
	                React.createElement("li", null, 
	                    React.createElement("div", {className: "media"}, 
	                        React.createElement("div", {className: "media-left"}, 
	                            React.createElement("a", {href: "http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve", target: "_blank"}, 
	                                React.createElement("img", {src: helpers_1.assets("press/whathifi.png")})
	                            )
	                        ), 
	                        React.createElement("div", {className: "media-body"}, 
	                            React.createElement("a", {href: "http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve", target: "_blank", className: "pressName"}, "WHATHIFI.COM"), 
	                            React.createElement("a", {href: "http://www.whathifi.com/ru/reportazh/vystavka-loudhead-2016-proshla-v-moskve", target: "_blank"}, 
	                                React.createElement("span", null, "Выставка LOUDHEAD 2016 прошла в Москве")
	                            ), 
	                            React.createElement("p", null, "Самый большой праздник у российских любителей хорошего звука и аудиогаджетов случается в тот день года, когда открывает свои двери, пожалуй, наиболее масштабная выставка, посвященная персональному аудио – Loudhead Audio Show.")))
	                ))));
	    };
	    return PressConference2016;
	}(React.Component));
	exports.PressConference2016 = PressConference2016;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var Brands = (function (_super) {
	    __extends(Brands, _super);
	    function Brands() {
	        _super.apply(this, arguments);
	    }
	    Brands.prototype.render = function () {
	        var brands = [];
	        for (var i = 0; i < 50; i++)
	            brands.push(i + 1);
	        return (React.createElement("section", {className: "newest-brands"}, brands.map(function (i) { return React.createElement("div", {key: i}, 
	            React.createElement("img", {src: helpers_1.assets("brands/" + i + ".png")})
	        ); })));
	    };
	    return Brands;
	}(React.Component));
	exports.Brands = Brands;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var react_router_1 = __webpack_require__(4);
	var store_1 = __webpack_require__(33);
	var DrawText_1 = __webpack_require__(36);
	var News = (function (_super) {
	    __extends(News, _super);
	    function News() {
	        _super.apply(this, arguments);
	    }
	    News.prototype.render = function () {
	        var news = store_1.newsStore.find();
	        return (React.createElement("section", {className: "news"}, 
	            React.createElement("h1", null, "Новости выставки"), 
	            React.createElement("a", {href: "https://www.facebook.com/doctorhead.russia/?ref=ts", target: "_blank"}, 
	                React.createElement("img", {src: helpers_1.assets("sony-b2.jpg"), className: "banner"})
	            ), 
	            React.createElement("div", {className: "preview"}, news.map(function (item) { return (React.createElement("article", {key: item._id}, 
	                item.cover ?
	                    (React.createElement("div", {className: "cover"}, 
	                        React.createElement(react_router_1.Link, {to: item.link ? item.link : ("/news/" + item._id)}, 
	                            React.createElement("img", {src: helpers_1.assets("news/" + item._id + "/" + item.cover), className: "img-responsive"})
	                        ), 
	                        React.createElement("b", null, item.date))) : '', 
	                React.createElement("h2", null, 
	                    React.createElement(react_router_1.Link, {to: item.link ? item.link : ("/news/" + item._id)}, item.title)
	                ), 
	                React.createElement("div", {className: "text"}, 
	                    React.createElement(DrawText_1.DrawText, {data: item.announce || item.preview})
	                ), 
	                React.createElement(react_router_1.Link, {to: item.link ? item.link : ("/news/" + item._id)}, "Подробнее"))); }))));
	    };
	    return News;
	}(React.Component));
	exports.News = News;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var mobx_1 = __webpack_require__(34);
	var news_1 = __webpack_require__(35);
	var NewsStore = (function () {
	    function NewsStore() {
	        var _this = this;
	        this.news = [];
	        (news_1["default"]).forEach(function (item) { return _this.updateItem(item); });
	    }
	    NewsStore.prototype.updateItem = function (item) {
	        this.news.push(item);
	    };
	    NewsStore.prototype.find = function () {
	        return this.news.slice();
	    };
	    NewsStore.prototype.findById = function (id) {
	        return this.news.filter(function (x) { return x._id === id; }).shift();
	    };
	    NewsStore.prototype.findSimilar = function (item) {
	        return this.news
	            .filter(function (x) { return x._id != item._id; })
	            .filter(function (x) { return x.tags.filter(function (tag) { return item.tags.indexOf(tag) >= 0; }).length > 0; });
	    };
	    __decorate([
	        mobx_1.observable
	    ], NewsStore.prototype, "news");
	    return NewsStore;
	}());
	exports.NewsStore = NewsStore;
	var News = (function () {
	    function News(data) {
	        this._id = data._id;
	        this.link = data.link;
	        this.title = data.title;
	        this.announce = data.announce;
	        this.preview = data.preview;
	        this.description = data.description;
	        this.tags = data.tags || [];
	        this.date = data.date;
	        this.cover = data.cover;
	    }
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "title");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "cover");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "link");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "preview");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "announce");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "description");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "tags");
	    __decorate([
	        mobx_1.observable
	    ], News.prototype, "date");
	    return News;
	}());
	exports.News = News;
	exports.newsStore = new NewsStore();


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(2))(78);

/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	exports.__esModule = true;
	exports["default"] = [
	    {
	        "_id": "57fd1747212b87c371f5444c",
	        "title": "Новинки Sony на выставке LOUDHEAD 2016",
	        "cover": "cover.jpg",
	        "link": "/sony",
	        "announce": [
	            {
	                "type": "h3",
	                "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться!"
	            },
	            {
	                "type": "p",
	                "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A"
	            }
	        ],
	        "preview": [
	            {
	                "type": "row",
	                "value": [
	                    {
	                        "type": "column",
	                        "size": ['sm12', 'md7'],
	                        "value": [
	                            {
	                                "type": "p",
	                                "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться, ведь все экспонаты, которые японцы показали в Берлине, вскоре можно будет посмотреть и пощупать на конференции LOUDHEAD в Москве."
	                            },
	                            {
	                                "type": "p",
	                                "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A"
	                            }
	                        ]
	                    },
	                    {
	                        "type": "column",
	                        "size": ['sm12', 'md5'],
	                        "value": [
	                            {
	                                "type": "image",
	                                "value": "/assets/news/57fd1747212b87c371f5444c/IFA2016_2.jpg"
	                            }
	                        ]
	                    }
	                ]
	            }
	        ],
	        "description": [
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444c/IFA2016_2.jpg"
	            },
	            {
	                "type": "h3",
	                "value": "Не успели попасть в павильон Sony на берлинской IFA? Не надо расстраиваться, ведь все экспонаты, которые японцы показали в Берлине, вскоре можно будет посмотреть и пощупать на конференции LOUDHEAD в Москве."
	            },
	            {
	                "type": "h3",
	                "value": "Компания Sony Electronics официально подтвердила свое участие в аудио-шоу LOUDHEAD со своими новыми продуктами: флагманским плеером Sony NW-WM1Z, аудиофильскими наушниками Sony MDR-Z1R, а также стационарным и портативным усилителями для наушников – Sony TA-ZH1ES и Sony PHA-2A"
	            },
	            {
	                "type": "p",
	                "value": [{ "line": "Чего именно нам ждать от новинок?" }, { "line": "Давайте посмотрим по порядку:" }]
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444c/NW-WM1Z-1.jpg"
	            },
	            {
	                "type": "p",
	                "value": ["Новый портативный флагман ", { "b": "Sony Walkman WM-1Z" }, " выглядит настоящим лидером. Солидный корпус из цельной бескислородной меди, отборная аудиофильская начинка начиная с топовых конденсаторов в цепи питания и заканчивая дорогостоящими многожильными кабелями во внутренней проводке. В этом портативном аудиоплеере больше передовых технологий, чем во многих домашних компонентах High End уровня."]
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444c/PHA-2A.jpg"
	            },
	            {
	                "type": "p",
	                "value": ["Вместе с Walkman WM-1Z на стенде Sony появится свежий флагманский ЦАП/усилитель ", { "b": "Sony PHA-2A" }, ". Устройство выполнено в прочном алюминиевом корпусе и привлекает внимание эффектным симметричным дизайном, но его основные достоинства спрятаны внутри: встроенный цифроаналоговый преобразователь PHA-2A умеет обрабатывать записи высокой четкости с разрешением до 5,6 МГц (DSD) и 32бит/192кГц (PCM), тактовый генератор отвечает за устранение джиттера, а усилитель работает в сверхшироком частотном диапазоне от инфразвуковых 10 Гц до ультразвуковых 100 кГц, чтобы даже у самого чувствительного аудиогения не возникло вопросов к качеству звука."]
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444c/MDR-Z1R.jpg"
	            },
	            {
	                "type": "p",
	                "value": ["Вместе с плеером WM-1Z и усилителем PHA-2A компания показывает еще одну важную флагманскую разработку - топовые High End наушники ", { "b": "Sony MDR-Z1R" }, " с гигантскими 70-миллиметровыми динамиками. Их уникальные диффузоры выполнены из сверхтонкой полимерной пленки с напылением из алюминия и куполами из магния, благодаря чему не деформируются при колебаниях на любой частоте. Ну а дизайн на наш взгляд просто великолепен. Он напоминает легендарные Sony MDR-R10, уверены, что эти наушники возьмут еще немало наград не только в области звука и уникальности акустического оформления, но и в области дизайна."]
	            },
	            {
	                "type": "h3",
	                "value": "Компания Sony также объявила о проведении эксклюзивной презентации специально для Loudhead 2016. На ней выступит специальный гость из японской штаб-квартиры Sony – инженер и создатель целого списка легенд среди которых те самые Sony MDR-R10 и известные любому звукорежиссеру эталонные Sony MDR-7506 – Хироаки Сато (Hiroaki Sato)."
	            },
	            {
	                "type": "h3",
	                "value": [
	                    { "line": "Инженер расскажет об истории и прогрессе наушников и звука, а также приоткроет тайны создания и устройства новых моделей флагманской линейки." },
	                    { "line": "Помимо увлекательного семинара от Хироаки Сато, компания Sony обещает подарки для всех слушателей и призы участникам семинара." }
	                ]
	            },
	            {
	                "type": "p",
	                "value": [
	                    { "line": "Время проведения презентации в рамках выставки Loudhead - 29 октября в 14.00" },
	                    { "line": "Москва КВЦ Сокольники, павильон 7а" }
	                ]
	            },
	            {
	                "type": "h3",
	                "value": "Зарегистрироваться на презентацию новинок Sony можно на сайте loudhead.ru"
	            }
	        ],
	        "tags": ["sony"],
	        "date": "11.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5444e",
	        "title": "Знакомьтесь: RHA",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Долгожданный российский дебют знаменитого британского бренда на Loudhead-2016"
	            },
	            {
	                "type": "p",
	                "value": "Имя RHA в России все еще известно немногим. А ведь этот породистый британский бренд уже не первый год славится своими внутриканальными наушниками высочайшего уровня! Премиальные материалы и ручная сборка, корпуса из металла и уникальные драйверы собственной разработки - в них есть все, что принято вкладывать в понятие «настоящее английское качество»."
	            }
	        ],
	        "description": [
	            {
	                "type": "h3",
	                "value": "Долгожданный российский дебют знаменитого британского бренда на Loudhead-2016"
	            },
	            {
	                "type": "p",
	                "value": "Имя RHA в России все еще известно немногим. А ведь этот породистый британский бренд уже не первый год славится своими внутриканальными наушниками высочайшего уровня! Премиальные материалы и ручная сборка, корпуса из металла и уникальные драйверы собственной разработки - в них есть все, что принято вкладывать в понятие «настоящее английское качество». На счету компании множество самых передовых ноу-хау, включая динамик DualCoil с двумя звуковыми катушками, вставленными одна в другую для максимально точной передачи звука на высоких и низких частотах. На выставке-шоу Loudhead-2016 британцы еамерены показать свои самые свежие разработки."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444e/cl750_banner.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Среди них - продвинутые внутриканальные RHA CL750 в корпусах из нержавеющей стали. Их запатентованные воздуховоды Airflow копируют плавные изгибы духовых инструментов, чтобы исключить звуковые искажения из-за трения воздуха. Конструкция магнитов и звуковых катушек в динамиках CL750 оптимизирована для точного контроля над звуком даже на пиках сигнала, а диффузоры переработаны для расширения частотного диапазона. Вот почему эти наушники способны воспроизводить частоты выше 40 кГц и по праву отмечены сертификатом Hi-Res. "
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444e/cl1_banner.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Еще больший интерес представляют флагманские модели RHA CL1 Ceramic. В их уникальной конструкции использованы сразу две пары мощных динамиков: к фирменным драйверам CL, отвечающим за бас и средние частоты, добавлены твитеры на запатентованной керамической подложке, выступающие в высокочастотном и ультразвуковом диапазоне. Эти наушники безупречно справляются даже с 45 кГц ультразвуком и отлично подходят для озвучивания аудиофильских хайрезов. Помимо двойного набора динамиков они снабжены двойным набором съемных кабелей: вместе со стандартным кабелем из бескислородной меди в комплект входит балансный кабель с проводниками из серебра."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444e/dacamp_banner.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Еще одной свежей разработкой RHA, которую россияне увидят на Loudhead-2016, станет первый портативный ЦАП/усилитель компании - RHA Dacamp L1. В основе его цифроаналоговой схемы - два раздельных ЦАП ESS Sabre 9018k2m для правого и левого каналов. Использование этих продвинутых чипов обеспечивает устройству незаурядные способности к обработке записей с высоким разрешением - до 32бит/384кГц у PCM и до 11.2 МГц у DSD. Помимо компьютеров и ноутбуков прибор готов работать в связке с любыми мобильными девайсами под управлением iOS или Android, а благодаря наличию двух выходов способен поддерживать как обычное, так и балансное подключение наушников. Для тех, кто любит поколдовать над звуком, аппарат оснащен регуляторами высоких и низких частот, а для тех, кто подолгу бывает вдалеке от розетки, вооружен емким аккумулятором на 4000 мАч. Его запаса хватает на 10 часов автономной работы! Вместе с ЦАП/усилителем и другими новинками RHA покажет в России всю линейку своих продуктов от самых демократичных моделей до бескомпромиссных топов. Для тех, кто интересуется по-настоящему качественным портативным звуком, дебют компании на Loudhead-2016 обещает массу интересных открытий!"
	            }
	        ],
	        "tags": [],
	        "date": "14.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5444f",
	        "title": "Металлическая музыка",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Наушники Focal Utopia с бериллиевыми диафрагмами на Loudhead-2016"
	            },
	            {
	                "type": "p",
	                "value": "Французский бренд Focal хорошо известен аудиофилам своей топовой High End акустикой с уникальными динамиками из сверхлегкого редкоземельного бериллия. Теперь компания продвигает свой новый высокотехнологичный High End продукт - топовые головные телефоны Focal Utopia, которые вскоре будут впервые презентованы в России на Loudhead-2016."
	            }
	        ],
	        "description": [
	            {
	                "type": "h3",
	                "value": "Наушники Focal Utopia с бериллиевыми диафрагмами на Loudhead-2016"
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444f/main.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Французский бренд Focal хорошо известен аудиофилам своей топовой High End акустикой с уникальными динамиками из сверхлегкого редкоземельного бериллия. Теперь компания продвигает свой новый высокотехнологичный High End продукт - топовые головные телефоны Focal Utopia, которые вскоре будут впервые презентованы в России на Loudhead-2016."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444f/1.png"
	            },
	            {
	                "type": "p",
	                "value": "40-миллиметровые динамики этих наушников интересны не только бериллиевыми мембранами, но и сверхтонкими подвесами из синтетических полимеров, а также облегченными звуковыми катушками, выполненными по бескаркасной технологии. Эти неординарные решения позволили конструкторам Focal минимизировать вес подвижных систем в динамиках, чтобы обеспечить им беспрецедентные импульсные характеристики."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444f/2.png"
	            },
	            {
	                "type": "p",
	                "value": "Частотный диапазон новых Focal Utopia тоже производит серьезное впечатление, простираясь от инфразвуковых 5 Гц до ультразвуковых 50 кГц. Яркие исполнительские таланты наушников гармонично сочетаются с их солидной внешностью, за которую отвечают карбоновые чашки и амбушюры из натуральной кожи. Полюбоваться незаурядным дизайном Focal Utopia, а главное, оценить качество их звучания, российские аудиофилы смогут уже в ближайшие дни на Loudhead-2016. И это далеко не единственный приятный сюрприз, который ждет посетителей выставки!"
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5444f/3.png"
	            }
	        ],
	        "tags": [],
	        "date": "14.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445a",
	        "title": "Чего ждать от Astell&Kern на Loudhead 2016?",
	        "cover": "cover.jpg",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров и две новинки"
	            },
	            {
	                "type": "p",
	                "value": "Один из лидеров в производстве портативных Hi-Fi систем, Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров, включая две новинки, практически одновременно поступившие на российский рынок."
	            }
	        ],
	        "description": [
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445a/main.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Один из лидеров в производстве портативных Hi-Fi систем, Astell& Kern представит свои самые актуальные и полюбившиеся модели плееров, включая две новинки, практически одновременно поступившие на российский рынок. Это АК70, в корпусе необычного мятного цвета, и АК300, младшая модель трехсотой серии, которая поддерживает аудио с кодированием до 24 бит / 192 кГц, студийный формат DSD поддерживается с перекодированием в PCM. Кроме того, у всех, кто еще не знаком с флагманским плеером АК380 и линейкой кастомных арматурных наушников второго поколения будет прекрасная возможность послушать этот необычный тандем собственными ушами."
	            },
	            {
	                "type": "p",
	                "value": "Плеер Astell&Kern AK70 - это пополнение в серии младших моделей портативных Hi-Fi проигрывателей именитого корейского бренда. По функционалу новинка занимает нишу между плеерами AK JR и AK300, а по дизайну AK70 является уникальным гаджетом, который, несомненно, найдёт почитателей среди ценителей первоклассного звука."
	            },
	            {
	                "type": "p",
	                "value": "Новинка поддерживает воспроизведение аудио с кодированием до 24 бит / 192 кГц, студийный формат DSD поддерживается с перекодированием в PCM. В плеере используется один ЦАП – CS4398 от Cirrus Logic, а также 64 Гб встроенной памяти. Устройство имеет как стандартный, так и балансный выход на наушники, а также цифровой выход для работы в режиме USB-ЦАП и USB-аудио."
	            },
	            {
	                "type": "p",
	                "value": "AK70 первый среди плееров Astell&Kern поддерживает вывод аудио через USB-порт. Вы можете подключать к AK70 разнообразные портативные усилители с помощью выхода USB. Плеер может транслировать записи в нативном DSD с помощью технологии DoP. Для подключения тех портативных усилителей, которые не обладают поддержкой технологии DoP, используется конвертация DSD в PCM."
	            },
	            {
	                "type": "p",
	                "value": "AK70 поддерживает работу в беспроводной сети, объединяющей компьютер, сетевой проигрыватель, мобильные устройства и другие плееры Astell&Kern. Такая конфигурация позволяет искать аудиофайлы на внешних носителях и воспроизводить музыку оттуда, используя Hi-Fi-плеер. Кроме того, AK70 совместим с CD-риппером Astell&Kern, что позволяет при использовании этих устройств вместе с лёгкостью копировать музыку с CD-дисков."
	            },
	            {
	                "type": "p",
	                "value": "Помимо вышеперечисленных моделей на Loudhead 2016 удастся подробно изучить такие модели как: ASTELL&KERN AK320, ASTELL&KERN AK380, ASTELL&KERN AK JR, ASTELL&KERN AK ROSIE, ASTELL&KERN AK ANGIE II, ASTELL&KERN AK LAYLA II, ASTELL&KERN AK T1p."
	            }
	        ],
	        "tags": [],
	        "date": "22.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445b",
	        "title": "Наследие Квинси Джонса: AKG N90Q на Loudhead-2016",
	        "cover": "cover.jpg",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "След семейства Джонс чувствуется в каждом компоненте"
	            },
	            {
	                "type": "p",
	                "value": "Приближающаяся выставка персонального аудио Loudhead-2016 покажет массу новинок, как среди любительской, так и профессиональной акустики. Посетители смогут протестировать  новые для российского рынка, премиальные наушники с активным шумоподавлением и индивидуальной настройкой звука – AKG N90Q."
	            }
	        ],
	        "description": [
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445b/1.jpg"
	            },
	            {
	                "type": "p",
	                "value": "След семейства Джонс чувствуется в каждом компоненте. Если Квинси приложил все своё мастерство к внутренней составляющей наушников, то внешним видом занималась его дочь, Кидада Джонс. Будучи дизайнером The Walt Disney Company, Кидада создала потрясающий дизайн для наушников, осуществив двойную колористику моделей. Наиболее известна золотая оболочка наушников, так и кричащая о своём высоком происхождении. Для аудиофилов с консервативными вкусами также создана модель в абсолютно чёрном цвете. Несмотря на цветовые предпочтения, конструкция AKG N90Q смоделирована самым наилучшим образом. Здесь пользователя ожидают и мягкие амбушюры из овечьей кожи с эффектом памяти, и колесо регулирования звука на одной из чашек, и едва ощутимый вес наушников - всего 40 грамм."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445b/2.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Внешняя красота AKG N90Q может в равной степени сравниться только с их содержимым. 52-мм поршневые динамики в купе с разработкой TruNote порадуют слушателя непревзойдённым качеством и высокой четкостью звука абсолютно в любом регистре частотного диапазона. Также, в наушниках установлен ЦАП, воспроизводящий Hi-Res формат без малейшей потери качества, а встроенная батарея продержит заряд наушников на протяжении 12 часов. "
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445b/3.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Чтобы узнать более детальные подробности о наушниках, получивших награду \"Best Product Sound on CES 2015\", приходите на Loudhead-2016! Мы ждём Вас!"
	            }
	        ],
	        "tags": [],
	        "date": "22.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445c",
	        "title": "Sennheiser PCX 550 Wireless на Loudhead-2016",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser"
	            },
	            {
	                "type": "p",
	                "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser, тем более если это Loudhead-2016. Среди многочисленных именитых новинок от немцев стоит ждать премиальную модель беспроводных наушников Sennheiser PXC 550 Wireless, способных составить достойную партию в каждом путешествии."
	            }
	        ],
	        "description": [
	            {
	                "type": "h3",
	                "value": "Редкая выставка проходит без участия в ней продуктов от знаменитого бренда Sennheiser, тем более если это Loudhead-2016. Среди многочисленных именитых новинок от немцев стоит ждать премиальную модель беспроводных наушников Sennheiser PXC 550 Wireless, способных составить достойную партию в каждом путешествии."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445c/1.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Дизайн PXC 550 Wireless отличается строгостью, определенной консервативностью, и как бы подчёркивает серьёзность своего обладателя. Чёрный матовый корпус, плавные переходящие линии складной конструкции, потрясающее качество сборки – от немцев другого ждать не приходится. Наушники сидят очень комфортно, и при условии своего полноразмерного типа, весят всего 227 грамм. В комплекте с наушниками идёт и качественно изготовленный чехол, без которого вряд ли пройдет хотя бы одна поездка. Плюс, внутри также найдётся кабель, необходимый для трансформации наушников из беспроводных в проводные. "
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445c/2.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Если в придачу к беспроводной модели вы хотите, чтобы она была и шумоизолирующей, то мимо наушников PXC 550 Wireless на Loudhead-2016 точно не стоит проходить. Такое управление внешним шумом редко доводится встречать. Во-первых, глубину подавления всегда можно отрегулировать. Наушники показывают отличное гашение шума на любой локации: в метро, в торговом центре в сезон скидок, да и просто на улице, забитой людьми и машинами. Во-вторых, наушники отлично демонстрируют себя в тот момент, когда вам нужно ответить на телефонный звонок. Внешний шум снижается, за счёт чего собеседник начинает вас лучше слышать, и одновременно с этим появляется возможность слышать свой голос, чтобы контролировать его громкость."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445c/3.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Звучание модели на 100% отвечает репутации компании и статусу «премиум». Несмотря на такие факторы, как Bluetooth и система понижения шума, PXC 550 Wireless удаётся воссоздать натуральное и отличающееся кристальной чистотой звучание. Линия нижнего регистра хорошо ощутима, объёмна, да и в принципе басы всегда считались сильной стороной Sennheiser. Середина выверена, детализация звуковых нюансов прослеживаемся в этом направлении в полной мере. С помощью прилагаемого в комплекте кабеля (с однокнопочным пультом управления и микрофоном), в целом, можно улучшить звучание модели, хотя разница и не будет столь глобальной. Звук прибавит в плотности, добавит красок звуковой сцене, но все это будет улучшением и без того прекрасного звучания. "
	            },
	            {
	                "type": "p",
	                "value": "Да и смысл говорить про возможности наушников, когда Вы и сами сможете все послушать и потрогать на приближающейся Loudhead-2016? Увидев Sennheiser PXC 550 Wireless, не забудьте их протестировать. Ждём Вас!"
	            }
	        ],
	        "tags": [],
	        "date": "25.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445d",
	        "title": "CustomShop на Loudhead 2016",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "В этом году на Loudhead будут представлены одни из наиболее популярных брендов кастомных наушников"
	            },
	            {
	                "type": "p",
	                "value": "Еще лет пять назад обзавестись кастомами было затратно не только по деньгам, но еще и по времени. Все лаборатории, занимающиеся их изготовлением, расположены были за рубежом, поэтому надо было проходить процедуру по изготовлению слепков и их отправке за границу. Теперь же кастомная продукция стала намного ближе и доступней благодаря CustomShop от Dr.Head."
	            }
	        ],
	        "description": [
	            {
	                "type": "h3",
	                "value": "В этом году на Loudhead будут представлены одни из наиболее популярных брендов кастомных наушников. Еще лет пять назад обзавестись кастомами было затратно не только по деньгам, но еще и по времени. Все лаборатории, занимающиеся их изготовлением, расположены были за рубежом, поэтому надо было проходить процедуру по изготовлению слепков и их отправке за границу. Теперь же кастомная продукция стала намного ближе и доступней благодаря CustomShop от Dr.Head."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445d/1.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Помимо возможности посмотреть и послушать привлекательные модели, всем желающим предложат сделать бесплатный слепок уха, по которому изготавливаются кастомы. Так же всем посетителям, желающим приобрести кастомные наушники гарантируется скидка 10% и скидка 25% на изготовление насадок и беруш. Но и это не все! На стенде CustomShop вы сможете подобрать эксклюзивные кабели фирмы LABKABEL для ваших внутриканальных и кастомных наушников."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445d/2.jpg"
	            },
	            {
	                "type": "p",
	                "value": [
	                    "Подробнее ознакомиться с кастомными наушниками можно ",
	                    {
	                        "type": "link",
	                        "value": "здесь",
	                        "link": "https://doctorhead.ru/customshop/",
	                        "target": "_blank"
	                    }
	                ]
	            }
	        ],
	        "tags": [],
	        "date": "26.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445e",
	        "title": "JVC Kenwood с новинкой HA-MX100-Z на Loudhead 2016",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Victor Entertainment анонсировала модель мониторных наушников HA-MX100-Z"
	            },
	            {
	                "type": "p",
	                "value": "Среди особенностей новинки – технология dual-clear bus port structure, которая обеспечивает оптимизацию давления на передней и задней камерах наушников, что в свою очередь улучшает точность звуковоспроизведения. Так же в HA-MX100-Z установлены драйверы, оснащенные распределителями звука, благодаря которым звуковая сцена становится широкой."
	            }
	        ],
	        "description": [
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445e/1.jpg"
	            },
	            {
	                "type": "p",
	                "value": "В перечне новинок мониторных наушников 2016 года компания JVC Kenwood в сотрудничестве со студией Victor Entertainment анонсировала привлекательную модель HA-MX100-Z. Среди особенностей новинки – технология dual-clear bus port structure, которая обеспечивает оптимизацию давления на передней и задней камерах наушников, что в свою очередь улучшает точность звуковоспроизведения. Так же в HA-MX100-Z установлены драйверы, оснащенные распределителями звука, благодаря которым звуковая сцена становится широкой."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445e/3.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Характеристики представляемой модели наушников претендуют на категорию профессиональных мониторов. Чувствительность HA-MX100-Z составляет 107 дБ, диапазон воспроизводимых частот простирается от 10 Гц до 40 КГц, импеданс составляет 56 ом, максимальная допустимая мощность — 1,5 ватта. Несмотря на то что эта модель позиционируется как профессиональные мониторные наушники, первичным разъёмом у HA-MX100-Z является привычный 3,5-мм «мини-джек». Так же и по параметрам веса они отличаются от своих «профессиональных коллег». Их вес всего 265 граммов."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445e/2.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Приходите на Loudhead 2016 чтобы оценить их по достоинству!"
	            }
	        ],
	        "tags": [],
	        "date": "26.10.2016"
	    },
	    {
	        "_id": "57fd1747212b87c371f5445f",
	        "title": "Ультракомпактные Final F7200 на Loudhead 2016!",
	        "cover": "cover.png",
	        "preview": [
	            {
	                "type": "h3",
	                "value": "Маленькие и ультралегкие наушники для точной посадки и высококачественной звукопередачи"
	            },
	            {
	                "type": "p",
	                "value": "Сверхплотная посадка наушников в ушном канале для оптимальных звуковых характеристик, более широкой звуковой картины и передачи богатых басов. Эти наушники отвечают всем вашим требованиям и не только!"
	            }
	        ],
	        "description": [
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445f/1.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Маленькие и ультралегкие наушники для точной посадки и высококачественной звукопередачи. Сверхплотная посадка наушников в ушном канале для оптимальных звуковых характеристик, более широкой звуковой картины и передачи богатых басов. Эти наушники отвечают всем вашим требованиям и не только!"
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445f/2.png"
	            },
	            {
	                "type": "p",
	                "value": "Возможность расположения драйвера наушника значительно глубже в ушном канале позволяет добиться более реалистичного звучания невероятно высокого качества. Для этого был существенно уменьшен корпус наушников F7200, сократив при этом и количество составляющих конструкцию элементов. Несмотря на то, что наушники выполнены из нержавеющей стали, их вес составляет всего 2 грамма, а диаметр не превышает 5,5 мм. Их конструкция исключает нежелательную вибрацию и позволяет насладиться невероятно чистым звучанием сигнала. Уникальный способ разработчиков Final использовать полнодиапазонные балансные арматурные драйверы во всех моделях обеспечивает потрясающее наполнение звука басами, неожиданное для наушников такого размера. Одной из последних разработок является кабель с серебряным напылением, способный создать более широкую звуковую картину. Данный кабель является съемным, что позволит подключить опциональные кабели с MMCX коннекторами. Наушники оборудованы заушным крючком, способствующим сокращению микрофонного эффекта кабеля. Эти наушники - флагман компании Final - воплощают в себе все аспекты высококачественного воспроизведения звука и простоту использования."
	            },
	            {
	                "type": "image",
	                "value": "/assets/news/57fd1747212b87c371f5445f/3.jpg"
	            },
	            {
	                "type": "p",
	                "value": "Посетите выставку Loudhead 2016 и познакомьтесь поближе с другими моделями из новой линейки Final!"
	            }
	        ],
	        "tags": [],
	        "date": "26.10.2016"
	    }
	];


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var mobx_1 = __webpack_require__(34);
	var DrawText = (function (_super) {
	    __extends(DrawText, _super);
	    function DrawText() {
	        _super.apply(this, arguments);
	        this.uniqueId = 0;
	    }
	    DrawText.prototype.getUniqueId = function () {
	        this.uniqueId++;
	        return "unique_id_" + this.uniqueId.toString();
	    };
	    DrawText.prototype.drawItem = function (item) {
	        var _this = this;
	        if (typeof item === 'string') {
	            return item;
	        }
	        else if (mobx_1.isObservableArray(item)) {
	            return item.map(function (x) { return _this.drawItem(x); });
	        }
	        switch (item.type) {
	            case 'row':
	                return (React.createElement("div", {className: "row", key: this.getUniqueId()}, item.value.map(function (x, j) { return _this.drawItem(x); })));
	            case 'column':
	                return (React.createElement("div", {className: item.size && item.size.map(function (x) { return x.replace(/^(.+)(\d+)$/, 'col-$1-$2'); }).join(' '), key: this.getUniqueId()}, item.value.map(function (x, j) { return _this.drawItem(x); })));
	            case 'image':
	                return (React.createElement("div", {className: "type-image", key: this.getUniqueId()}, 
	                    item.title ? React.createElement("span", null, this.drawItem(item.value)) : '', 
	                    React.createElement("img", {style: item.style || {}, src: item.value, className: "img-responsive"})));
	            case 'h1':
	                return React.createElement("h1", {key: this.getUniqueId()}, this.drawItem(item.value));
	            case 'h2':
	                return React.createElement("h2", {key: this.getUniqueId()}, this.drawItem(item.value));
	            case 'h3':
	                return React.createElement("h3", {key: this.getUniqueId()}, this.drawItem(item.value));
	            case 'h4':
	                return React.createElement("h4", {key: this.getUniqueId()}, this.drawItem(item.value));
	            case 'h5':
	                return React.createElement("h5", {key: this.getUniqueId()}, this.drawItem(item.value));
	            case 'link':
	                return React.createElement("a", {key: this.getUniqueId(), href: item.link, target: item.target, title: item.title}, item.value);
	            case 'list':
	                return (React.createElement("ul", {key: this.getUniqueId()}, item.value.map(function (value, i) { return React.createElement("li", {key: _this.getUniqueId()}, _this.drawItem(value)); })));
	            case 'line':
	                return React.createElement("span", {key: this.getUniqueId()}, 
	                    item.value, 
	                    React.createElement("br", null));
	            case 'inline':
	                return React.createElement("span", {key: this.getUniqueId()}, item.value);
	            case 'b':
	                return React.createElement("b", {key: this.getUniqueId()}, item.value);
	            case 'p':
	                return React.createElement("p", {className: "type-p", key: this.getUniqueId()}, this.drawItem(item.value));
	            default:
	                return ['line', 'inline', 'b']
	                    .filter(function (key) { return item[key]; })
	                    .map(function (key) { return _this.drawItem({ type: key, value: item[key] }); });
	        }
	    };
	    DrawText.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", {className: "text"}, this.props.data.map(function (item) { return _this.drawItem(item); })));
	    };
	    return DrawText;
	}(React.Component));
	exports.DrawText = DrawText;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var helpers_1 = __webpack_require__(5);
	var Registration_1 = __webpack_require__(38);
	var News_1 = __webpack_require__(39);
	var Map_1 = __webpack_require__(26);
	var Sony = (function (_super) {
	    __extends(Sony, _super);
	    function Sony() {
	        _super.apply(this, arguments);
	    }
	    Sony.prototype.render = function () {
	        return (React.createElement("div", {className: "sony"}, 
	            React.createElement("div", null, 
	                React.createElement("img", {src: helpers_1.assets("sony-banner.png"), className: "img-responsive", style: { width: '100%' }})
	            ), 
	            React.createElement(Registration_1.Registration, null), 
	            React.createElement(News_1.News, null), 
	            React.createElement(Map_1.Map, null)));
	    };
	    return Sony;
	}(React.Component));
	exports.Sony = Sony;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var $ = __webpack_require__(7);
	var Registration = (function (_super) {
	    __extends(Registration, _super);
	    function Registration(props) {
	        _super.call(this, props);
	        this.state = {
	            sent: false
	        };
	    }
	    Registration.prototype.register = function (e) {
	        var _this = this;
	        e.preventDefault();
	        $.post('/loudhead/2016/reg', $(e.target).serialize(), function (data) {
	            if (data) {
	                _this.setState({ sent: true, ticket: data.ticket });
	            }
	            else {
	                alert('Что-то пошло не так. Проверьте правильность заполнения формы и попробуйте еще раз.');
	            }
	        }, 'json').error(function () {
	            alert('Что-то пошло не так. Попробуйте еще раз.');
	        });
	    };
	    Registration.prototype.render = function () {
	        return (React.createElement("section", {className: "sony-form"}, 
	            React.createElement("div", {className: "inner"}, 
	                React.createElement("div", {className: "sent"}, 
	                    React.createElement("h1", null, "Регистрация на VIP-стенд Sony закрыта"), 
	                    React.createElement("p", null, "Вы можете зарегистрироваться на выставке LOUDHEAD и посетить стенд Sony в течение всех дней работы выставки в обычном режиме."))
	            )
	        ));
	    };
	    return Registration;
	}(React.Component));
	exports.Registration = Registration;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var store_1 = __webpack_require__(33);
	var react_router_1 = __webpack_require__(4);
	var DrawText_1 = __webpack_require__(36);
	var News = (function (_super) {
	    __extends(News, _super);
	    function News(props) {
	        _super.call(this, props);
	        this.news = store_1.newsStore;
	    }
	    News.prototype.render = function () {
	        var item = this.news.findById("57fd1747212b87c371f5444c");
	        var similar = this.news.findSimilar(item);
	        if (item) {
	            return (React.createElement("section", {className: "news"}, 
	                React.createElement("h1", null, "Новости выставки"), 
	                React.createElement("div", {className: "latest"}, 
	                    React.createElement("article", null, 
	                        React.createElement("b", null, item.date), 
	                        React.createElement("h2", null, 
	                            React.createElement(react_router_1.Link, {to: "/news/" + item._id}, item.title)
	                        ), 
	                        React.createElement(DrawText_1.DrawText, {data: item.preview}), 
	                        React.createElement("p", null, 
	                            React.createElement(react_router_1.Link, {to: "/news/" + item._id}, "Читать новость полностью")
	                        ))
	                ), 
	                similar.length > 0 ? (React.createElement("div", {className: "similar"}, 
	                    React.createElement("h3", null, "Еще новости по теме:"), 
	                    React.createElement("ul", null, similar.map(function (item) {
	                        return (React.createElement("li", {key: item._id}, 
	                            React.createElement(react_router_1.Link, {to: "/news/" + item._id}, item.title)
	                        ));
	                    })))) : ''));
	        }
	        else {
	            return React.createElement("div", null);
	        }
	    };
	    return News;
	}(React.Component));
	exports.News = News;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var GalleryConference_1 = __webpack_require__(27);
	var helpers_1 = __webpack_require__(5);
	var $ = __webpack_require__(7);
	var Members = (function (_super) {
	    __extends(Members, _super);
	    function Members(props) {
	        _super.call(this, props);
	        this.state = { sent: false };
	    }
	    Members.prototype.register = function (e) {
	        var _this = this;
	        e.preventDefault();
	        $.post('/loudhead/2016/reg', $(e.target).serialize(), function (data) {
	            if (data) {
	                _this.setState({ sent: true, ticket: data.ticket });
	            }
	            else {
	                alert('Что-то пошло не так. Проверьте правильность заполнения формы и попробуйте еще раз.');
	            }
	        }, 'json').error(function () {
	            alert('Что-то пошло не так. Попробуйте еще раз.');
	        });
	    };
	    Members.prototype.render = function () {
	        return (React.createElement("div", null, 
	            React.createElement("section", {id: "member-reg", className: "heading"}, 
	                React.createElement("a", {name: "form"}), 
	                React.createElement("div", null, 
	                    React.createElement("div", {id: "member-registration"}, 
	                        React.createElement("h1", {className: "text-center"}, "Регистрация участников закрыта"), 
	                        React.createElement("hr", null), 
	                        React.createElement("div", {style: { color: 'white' }}, "Если вы планируете посетить выставку LOUDHEAD, то можете зарегистрироваться на нее непосредственно в дни проведения мероприятия."))
	                )), 
	            React.createElement("section", {className: "members"}, 
	                React.createElement("article", {className: "clearfix"}, 
	                    React.createElement("img", {src: helpers_1.assets("members/1.png")}), 
	                    React.createElement("aside", null, 
	                        React.createElement("h2", null, "Loudhead - встреча любителей персонального аудио."), 
	                        React.createElement("p", null, "Формат встреч любителей персонального аудио популярен во всем мире. Лидеры мнений, форумчане, блогеры - словом все любители и ценители персонального звука собираются на одной площадке, где могут послушать и поделиться мнениями обо всех новинках и, уже ставших классическими моделях. Более того, всегда есть возможность составить свой тракт или похвастаться собственной системой. Именно эти возможности с каждым годом привлекают на такие мероприятия всё больше и больше любителей персонального аудио."))), 
	                React.createElement("div", null, 
	                    React.createElement("h2", null, "Чем встреча любителей персонального аудио отличается от тематических выставок?"), 
	                    React.createElement("div", {className: "points"}, 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "1"), 
	                            React.createElement("div", {className: "point"}, "Встреча любителей персонального аудио - это формат отличный от специализированных выставок. Попасть на такое мероприятие могут далеко не все желающие. По предварительному приглашению, либо регистрации - всем гостям высылается персональное приглашение.")), 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "2"), 
	                            React.createElement("div", {className: "point"}, "Формат мероприятия позволяет протестировать все экспонаты без исключения и подключить к ним любые свои девайсы при желании. Так же есть уникальная возможность продемонстрировать свои “домашние” системы и связки.")), 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "3"), 
	                            React.createElement("div", {className: "point"}, "Мероприятие проводится в формате домашней дружеской встречи, во время которой у всех гостей есть возможность задать любые вопросы представителям компаний-производителей, пообщаться с единомышленниками, обменяться мнениями, поделиться впечатлениями от прослушанного оборудования.")))), 
	                React.createElement(GalleryConference_1.GalleryConference, null), 
	                React.createElement("div", null, 
	                    React.createElement("h2", null, "Что особенного во встречах любителей персонального аудио?"), 
	                    React.createElement("div", {className: "points"}, 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "1"), 
	                            React.createElement("div", {className: "point"}, "Встреча любителей персонального аудио одно из самых ожидаемых событий в кругах лидеров мнений отрасли и всех  любителей персонального аудио, которые посещают форумы и обсуждают новинки ежедневно.")), 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "2"), 
	                            React.createElement("div", {className: "point"}, "На таких мероприятиях есть уникальная возможность увидеть и протестировать системы не только известных производителей, но и собственноручно собранные или “прокачанные” творения самих пользователей.")), 
	                        React.createElement("div", {className: "row"}, 
	                            React.createElement("div", {className: "n"}, "3"), 
	                            React.createElement("div", {className: "point"}, "Встреча будет интересна не только производителем и пользователям, но и всем специализированным ресурсам, так как является на данный момент уникальным явлением в России и позволяет преподнести отрасль с новой стороны своим читателям.")))), 
	                React.createElement("div", {className: "center"}, 
	                    React.createElement("a", {href: "#form", className: "btn"}, "Отправить заявку на участие")
	                ), 
	                React.createElement("hr", null))));
	    };
	    return Members;
	}(React.Component));
	exports.Members = Members;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var MainBanner_1 = __webpack_require__(9);
	var Program_1 = __webpack_require__(42);
	var Map_1 = __webpack_require__(26);
	var GalleryConference_1 = __webpack_require__(27);
	var Brands_1 = __webpack_require__(31);
	var Visitors = (function (_super) {
	    __extends(Visitors, _super);
	    function Visitors() {
	        _super.apply(this, arguments);
	    }
	    Visitors.prototype.render = function () {
	        return (React.createElement("div", {className: "visitors"}, 
	            React.createElement(MainBanner_1.MainBanner, {compact: true}), 
	            React.createElement(Program_1.Program, null), 
	            React.createElement("div", {className: "run-a-game"}, 
	                React.createElement("div", {className: "bn"}, "Не пропусти розыгрыш подарков" + ' ' + "по номеру пригласительного билета!")
	            ), 
	            React.createElement(Brands_1.Brands, null), 
	            React.createElement(GalleryConference_1.GalleryConference, null), 
	            React.createElement("div", {className: "row"}, 
	                React.createElement(Map_1.Map, null)
	            )));
	    };
	    return Visitors;
	}(React.Component));
	exports.Visitors = Visitors;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var Program = (function (_super) {
	    __extends(Program, _super);
	    function Program() {
	        _super.apply(this, arguments);
	    }
	    Program.prototype.render = function () {
	        return (React.createElement("section", {className: "program"}, 
	            React.createElement("h1", null, "Программа мероприятия"), 
	            React.createElement("div", null, 
	                React.createElement("aside", null, 
	                    React.createElement("h2", null, "Суббота"), 
	                    React.createElement("div", {className: "schedule"}, 
	                        React.createElement("b", null, "10:00"), 
	                        React.createElement("span", null, "Торжественное открытие Мероприятия"), 
	                        React.createElement("b", null, "11:00 — 11:30"), 
	                        React.createElement("span", null, "История AKG"), 
	                        React.createElement("b", null, "12:00 — 12:30"), 
	                        React.createElement("span", null, "Российская премьера! Презентация серии F — ультракомпактных японских наушников Final. "), 
	                        React.createElement("b", null, "13:00 — 13:30"), 
	                        React.createElement("span", null, "Презентация нового британского бренда — RHA"), 
	                        React.createElement("b", null, "14:00 — 15:00"), 
	                        React.createElement("span", null, "Официальная презентация новых продуктов SONY в России"), 
	                        React.createElement("b", null, "16:00 — 16:30"), 
	                        React.createElement("span", null, "Семинар: Наушники Электростатические Stax новой серии Лямбда"), 
	                        React.createElement("b", null, "17:00 — 17:30"), 
	                        React.createElement("span", null, "BOSE — система активного шумоподавления. 40 лет развития технологии."), 
	                        React.createElement("b", null, "18:00 — 18:30"), 
	                        React.createElement("span", null, "Вручение наград \"продукт года\" по версии LOUDHEAD"))), 
	                React.createElement("aside", null, 
	                    React.createElement("h2", null, "Воскресенье"), 
	                    React.createElement("div", {className: "schedule"}, 
	                        React.createElement("b", null, "10:00"), 
	                        React.createElement("span", null, "Открытие второго дня"), 
	                        React.createElement("b", null, "11:00 — 11:30"), 
	                        React.createElement("span", null, "История AKG"), 
	                        React.createElement("b", null, "12:00 — 12:30"), 
	                        React.createElement("span", null, "Российская премьера! Презентация серии F — ультракомпактных японских наушников Final."), 
	                        React.createElement("b", null, "13:00 — 13:30"), 
	                        React.createElement("span", null, "Презентация нового британского бренда — RHA"), 
	                        React.createElement("b", null, "16:00 — 16:30"), 
	                        React.createElement("span", null, "BOSE — система активного шумоподавления. 40 лет развития технологии."), 
	                        React.createElement("b", null, "17:00 — 17:30"), 
	                        React.createElement("span", null, "Вручение наград лучшим системам форума DrHead"), 
	                        React.createElement("b", null, "18:00 — 18:30"), 
	                        React.createElement("span", null, "Окончание выставки"))))));
	    };
	    return Program;
	}(React.Component));
	exports.Program = Program;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var Map_1 = __webpack_require__(26);
	var DrawText_1 = __webpack_require__(36);
	var MainBanner_1 = __webpack_require__(9);
	var store_1 = __webpack_require__(33);
	var react_router_1 = __webpack_require__(4);
	var helpers_1 = __webpack_require__(5);
	var NewsRead = (function (_super) {
	    __extends(NewsRead, _super);
	    function NewsRead() {
	        _super.apply(this, arguments);
	    }
	    NewsRead.prototype.render = function () {
	        var item = store_1.newsStore.findById(this.props.params['id']);
	        var back = function (e) {
	            e.preventDefault();
	            if (helpers_1.historyState.pushes > 0) {
	                react_router_1.browserHistory.goBack();
	            }
	            else {
	                react_router_1.browserHistory.push('/');
	            }
	        };
	        return (React.createElement("div", null, 
	            React.createElement(MainBanner_1.MainBanner, {compact: true}), 
	            React.createElement("section", {className: "news-read"}, 
	                React.createElement("a", {href: "#", onClick: back, className: "back"}, "Вернуться назад"), 
	                React.createElement("article", null, 
	                    React.createElement("b", null, item.date), 
	                    React.createElement("h2", null, item.title), 
	                    React.createElement(DrawText_1.DrawText, {data: item.description}))), 
	            React.createElement("div", {className: "row"}, 
	                React.createElement(Map_1.Map, null)
	            )));
	    };
	    return NewsRead;
	}(React.Component));
	exports.NewsRead = NewsRead;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var Program_1 = __webpack_require__(42);
	var Map_1 = __webpack_require__(26);
	var GalleryConference_1 = __webpack_require__(27);
	var Brands_1 = __webpack_require__(31);
	var $ = __webpack_require__(7);
	var Paid = (function (_super) {
	    __extends(Paid, _super);
	    function Paid(props) {
	        _super.call(this, props);
	        this.state = {
	            id: this.props.params['id'],
	            paid: false,
	            price: null,
	            status: false
	        };
	    }
	    Paid.prototype.componentDidMount = function () {
	        this.updateData();
	    };
	    Paid.prototype.updateData = function () {
	        var _this = this;
	        $.get('/reg/get', { id: this.state.id }, function (data) {
	            if (data.hasOwnProperty('error')) {
	                alert(data.error);
	            }
	            else {
	                _this.setState({ status: true, id: data._id, price: data.price, paid: data.paid });
	            }
	        }, 'json').error(function () {
	            alert('Что-то пошло не так. Попробуйте еще раз.');
	        });
	    };
	    Paid.prototype.render = function () {
	        if (this.state.status) {
	            return (React.createElement("div", {className: "visitors"}, 
	                React.createElement("h1", null, "Оплата выполнена"), 
	                React.createElement("div", {className: "note"}, 
	                    React.createElement("a", {className: "btn", href: "/ticket.html?" + this.state.id, target: "_blank"}, 
	                        "Распечатайте ваш билет ", 
	                        this.state.number)
	                ), 
	                React.createElement(Program_1.Program, null), 
	                React.createElement("div", {className: "run-a-game"}, 
	                    React.createElement("div", {className: "bn"}, "Не пропусти розыгрыш подарков" + ' ' + "по номеру пригласительного билета!")
	                ), 
	                React.createElement(Brands_1.Brands, null), 
	                React.createElement(GalleryConference_1.GalleryConference, null), 
	                React.createElement("div", {className: "row"}, 
	                    React.createElement(Map_1.Map, null)
	                )));
	        }
	        else {
	            return (React.createElement("div", {className: "visitors"}, 
	                React.createElement("h1", null, "Загружается информация об оплате, подождите...")
	            ));
	        }
	    };
	    return Paid;
	}(React.Component));
	exports.Paid = Paid;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var react_router_1 = __webpack_require__(4);
	var $ = __webpack_require__(7);
	var Accounting = (function (_super) {
	    __extends(Accounting, _super);
	    function Accounting(props) {
	        _super.call(this, props);
	        this.state = {
	            code: '',
	            data: []
	        };
	    }
	    Accounting.prototype.find = function (e) {
	        var _this = this;
	        var code = e.target.value;
	        this.setState({ code: code, data: [] });
	        $.getJSON('/reg/find', { code: code, r: Math.random() }, function (data) {
	            _this.setState({ code: code, data: data });
	        });
	    };
	    Accounting.prototype.register = function (item) {
	        var _this = this;
	        item.registered = new Date().toISOString();
	        $.post("/reg/user/update?id=" + item._id, { registered: new Date().toISOString() }, function (response) {
	            if (response === true) {
	                _this.setState({ code: _this.state.code, data: _this.state.data });
	            }
	            else {
	                alert(response.error);
	            }
	        }, 'json');
	    };
	    Accounting.prototype.getType = function (type, item) {
	        switch (type) {
	            case 'sony':
	                return 'VIP Sony' + (item.gift ? ' + подарок' : '');
	            case 'user':
	                return 'Посетитель';
	            case 'brand':
	                return 'Участник';
	            case 'partner':
	                return 'Партнер';
	        }
	    };
	    Accounting.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", {className: "dashboard"}, 
	            React.createElement(react_router_1.Link, {className: "back", to: "/dashboard"}, "Вернуться в панель управления"), 
	            React.createElement("h1", null, "Регистрация участников конференции LOUDHEAD 2016"), 
	            React.createElement("form", null, 
	                React.createElement("input", {autoComplete: "off", autoFocus: true, placeholder: "Введите номер билета", type: "text", name: "code", value: this.state.code, onChange: function (e) { return _this.find(e); }})
	            ), 
	            React.createElement("table", null, 
	                React.createElement("thead", null, 
	                    React.createElement("tr", null, 
	                        React.createElement("th", null, "№"), 
	                        React.createElement("th", null, "Тип"), 
	                        React.createElement("th", null, "Имя"), 
	                        React.createElement("th", null, "Email"), 
	                        React.createElement("th", null, "Телефон"), 
	                        React.createElement("th", null, "Зарегистрирован"))
	                ), 
	                React.createElement("tbody", null, 
	                    this.state.data.length === 5 && (React.createElement("tr", null, 
	                        React.createElement("td", {colSpan: 6}, "Показано 5 совпадений. Уточните запрос, чтобы получить нужный результат.")
	                    )), 
	                    this.state.data.map(function (item) { return (React.createElement("tr", {key: item._id}, 
	                        React.createElement("td", null, 
	                            React.createElement("b", {style: { fontSize: '150%' }}, parseInt(item._id.substr(-5), 16)), 
	                            React.createElement("br", null), 
	                            item.registered
	                                ? React.createElement("div", null, 
	                                    "Зарегистрирован:", 
	                                    React.createElement("br", null), 
	                                    new Date(item.registered).toLocaleString())
	                                : React.createElement("button", {onClick: function (e) { return _this.register(item); }}, "Регистрация")), 
	                        React.createElement("td", null, _this.getType(item.type, item)), 
	                        React.createElement("td", null, 
	                            item.name, 
	                            " ", 
	                            item.lastName), 
	                        React.createElement("td", null, item.email), 
	                        React.createElement("td", null, item.phone), 
	                        React.createElement("td", null, item.date && new Date(item.date).toLocaleString()))); }), 
	                    this.state.data.length === 0 && (React.createElement("tr", null, 
	                        React.createElement("td", {colSpan: 6}, this.state.code ? 'Ничего не найдено' : 'Нет данных для поиска')
	                    )))), 
	            React.createElement("br", null)));
	    };
	    return Accounting;
	}(React.Component));
	exports.Accounting = Accounting;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var react_router_1 = __webpack_require__(4);
	var Dashboard = (function (_super) {
	    __extends(Dashboard, _super);
	    function Dashboard(props) {
	        _super.call(this, props);
	        this.state = { table: '' };
	    }
	    Dashboard.prototype.changeTable = function (e) {
	        this.setState({ table: e.target.value });
	    };
	    Dashboard.prototype.openTable = function (e) {
	        e.preventDefault();
	        if (this.state.table) {
	            window.open('/table/' + this.state.table, '_blank');
	        }
	    };
	    Dashboard.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", {className: "dashboard"}, 
	            React.createElement("h1", null, "Конференция LOUDHEAD 2016"), 
	            React.createElement("div", null, 
	                React.createElement("p", null, "На этой странице можно открыть инструменты для регистрации участников и систему для голосования за стол.")
	            ), 
	            React.createElement("div", null, 
	                React.createElement(react_router_1.Link, {className: "go", to: "/dashboard/accounting"}, "Регистрация участников")
	            ), 
	            React.createElement("form", null, 
	                React.createElement("input", {onChange: function (e) { return _this.changeTable(e); }, type: "text", value: this.state.table, placeholder: "Введите номер стола"}), 
	                " ", 
	                this.state && this.state.table && React.createElement("button", {onClick: function (e) { return _this.openTable(e); }}, "Открыть голосование за стол"))));
	    };
	    return Dashboard;
	}(React.Component));
	exports.Dashboard = Dashboard;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var Layout_1 = __webpack_require__(6);
	var $ = __webpack_require__(7);
	window['$'] = $;
	window['jQuery'] = $;
	var Restricted = (function (_super) {
	    __extends(Restricted, _super);
	    function Restricted(props) {
	        _super.call(this, props);
	        this.state = { granted: false };
	    }
	    Restricted.prototype.validateToken = function (e) {
	        var _this = this;
	        $.getJSON('/reg/dashboard?token=' + e.target.value, function (granted) {
	            _this.setState({ granted: granted });
	        });
	    };
	    Restricted.prototype.render = function () {
	        var _this = this;
	        return (React.createElement(Layout_1.Layout, null, this.state.granted
	            ? this.props.children
	            : React.createElement("div", {className: "token"}, 
	                React.createElement("input", {autoFocus: true, placeholder: "Введите код доступа", type: "text", onChange: function (e) { return _this.validateToken(e); }})
	            )));
	    };
	    return Restricted;
	}(React.Component));
	exports.Restricted = Restricted;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(1);
	var $ = __webpack_require__(7);
	var prevClass = '';
	var Table = (function (_super) {
	    __extends(Table, _super);
	    function Table(props) {
	        _super.call(this, props);
	        this.state = {
	            sent: false,
	            code: '',
	            error: '',
	            dialog: false
	        };
	    }
	    Table.prototype.componentWillMount = function () {
	        prevClass = document.body.className;
	        document.body.className += ' desk';
	    };
	    Table.prototype.componentWillUnmount = function () {
	        document.body.className = prevClass;
	    };
	    Table.prototype.showVoteDialog = function (e) {
	        e.preventDefault();
	        this.setState({ code: this.state.code, error: this.state.error, dialog: true, sent: this.state.sent });
	    };
	    Table.prototype.updateCode = function (e) {
	        this.setState({ code: e.target.value, error: '', dialog: this.state.dialog, sent: this.state.sent });
	    };
	    Table.prototype.sendVote = function (e) {
	        var _this = this;
	        $.post('/reg/vote', { table: this.props.params.table, code: this.state.code }, function (data) {
	            if (data === true) {
	                _this.setState({ code: _this.state.code, error: '', dialog: _this.state.dialog, sent: true });
	            }
	            else {
	                _this.setState({ code: _this.state.code, error: data.error, dialog: _this.state.dialog, sent: false });
	            }
	        }, 'json');
	    };
	    Table.prototype.reset = function (e) {
	        this.setState({ code: '', error: '', dialog: false, sent: false });
	    };
	    Table.prototype.render = function () {
	        var _this = this;
	        return (React.createElement("div", {className: "desk-table"}, 
	            React.createElement("h1", null, 
	                "Голосование", 
	                React.createElement("br", null), 
	                " за лучшую систему"), 
	            React.createElement("h2", null, 
	                "Стол № ", 
	                this.props.params.table), 
	            React.createElement("div", {className: "initial"}, 
	                React.createElement("button", {onClick: function (e) { return _this.showVoteDialog(e); }, type: "button"}, "Проголосовать")
	            ), 
	            React.createElement("div", {ref: "vote-dialog", className: "vote-dialog", style: { display: this.state.dialog ? 'block' : 'none' }}, !this.state.sent
	                ? React.createElement("div", null, 
	                    this.state.error ? React.createElement("h4", null, this.state.error) : React.createElement("h3", null, "Укажите регистрационный код"), 
	                    React.createElement("p", null, 
	                        React.createElement("input", {type: "number", onChange: function (e) { return _this.updateCode(e); }, value: this.state.code})
	                    ), 
	                    React.createElement("p", null, 
	                        React.createElement("button", {type: "button", onClick: function (e) { return _this.sendVote(e); }}, "Отправить")
	                    ))
	                : React.createElement("div", null, 
	                    React.createElement("h3", null, "Спасибо! Ваш голос учтен!"), 
	                    React.createElement("p", null, 
	                        React.createElement("button", {type: "button", onClick: function (e) { return _this.reset(e); }, className: "close"}, "Закрыть")
	                    )))));
	    };
	    return Table;
	}(React.Component));
	exports.Table = Table;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.ad0004.js
 **/